import * as React from 'react';

const SoundWaveIcon = ({fillColor = '#2d2756', width = 0}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={'27.2'}
    viewBox="0 0 110 27.2"
    preserveAspectRatio="none">
    <g fill={fillColor}>
      <path
        data-name="Path 151"
        d="M118.678 14.127H.479a.535.535 0 0 1 0-1.064h118.2a.535.535 0 0 1 0 1.064Z"
      />
      <path
        data-name="Path 152"
        d="M116.588 15.722a3.663 3.663 0 0 1-.371-1.064 5.542 5.542 0 0 1-.1-1.064 5.465 5.465 0 0 1 .1-1.064.6.6 0 1 1 .745 0 5.47 5.47 0 0 1 .1 1.064 5.543 5.543 0 0 1-.1 1.064 3.664 3.664 0 0 1-.374 1.064Z"
      />
      <path
        data-name="Path 153"
        d="M115.641 17.175a9.3 9.3 0 0 1-.371-1.79 15.555 15.555 0 0 1-.1-1.791 15.335 15.335 0 0 1 .1-1.791 9.17 9.17 0 0 1 .372-1.791 9.17 9.17 0 0 1 .372 1.791 15.377 15.377 0 0 1 .1 1.791 15.608 15.608 0 0 1-.1 1.791 9.289 9.289 0 0 1-.373 1.79Z"
      />
      <path
        data-name="Path 154"
        d="M114.694 17.92a13.269 13.269 0 0 1-.371-2.163c-.07-.721-.1-1.442-.1-2.163s.032-1.442.1-2.163a13.1 13.1 0 0 1 .372-2.163 13.1 13.1 0 0 1 .372 2.163 23.364 23.364 0 0 1 0 4.326 13.278 13.278 0 0 1-.373 2.163Z"
      />
      <path
        data-name="Path 155"
        d="M113.747 18.788a18.963 18.963 0 0 1-.371-2.6c-.07-.866-.1-1.731-.1-2.6s.032-1.732.1-2.6a18.663 18.663 0 0 1 .373-2.6 18.662 18.662 0 0 1 .372 2.6q.1 1.3.1 2.6c0 .866-.033 1.731-.1 2.6a18.967 18.967 0 0 1-.374 2.6Z"
      />
      <path
        data-name="Path 156"
        d="M112.8 18.044a14.037 14.037 0 0 1-.371-2.225c-.07-.742-.1-1.483-.1-2.225s.032-1.483.1-2.225a13.833 13.833 0 0 1 .372-2.225 13.855 13.855 0 0 1 .372 2.225q.1 1.112.1 2.225t-.1 2.225a14.039 14.039 0 0 1-.373 2.225Z"
      />
      <path
        data-name="Path 157"
        d="M111.853 17.441a10.625 10.625 0 0 1-.371-1.923 17.91 17.91 0 0 1-.1-1.923 17.691 17.691 0 0 1 .1-1.923 10.5 10.5 0 0 1 .372-1.924 10.5 10.5 0 0 1 .372 1.924 17.706 17.706 0 0 1 .1 1.923 17.989 17.989 0 0 1-.1 1.923 10.627 10.627 0 0 1-.373 1.923Z"
      />
      <path
        data-name="Path 158"
        d="M110.906 16.785a7.5 7.5 0 0 1-.371-1.6 12.378 12.378 0 0 1-.1-1.6 12.184 12.184 0 0 1 .1-1.6 7.4 7.4 0 0 1 .372-1.6 7.4 7.4 0 0 1 .372 1.6 12.205 12.205 0 0 1 .1 1.6 12.409 12.409 0 0 1-.1 1.6 7.5 7.5 0 0 1-.373 1.6Z"
      />
      <path
        data-name="Path 159"
        d="M109.958 15.722a3.67 3.67 0 0 1-.371-1.064 5.554 5.554 0 0 1-.1-1.064 5.469 5.469 0 0 1 .1-1.064.6.6 0 1 1 .745 0 5.47 5.47 0 0 1 .1 1.064 5.538 5.538 0 0 1-.1 1.064 3.667 3.667 0 0 1-.374 1.064Z"
      />
      <path
        data-name="Path 160"
        d="M109.011 15.172a2.307 2.307 0 0 1-.371-.789 3.075 3.075 0 0 1-.1-.789 3.025 3.025 0 0 1 .1-.789.482.482 0 1 1 .745 0 3.03 3.03 0 0 1 .1.789 3.076 3.076 0 0 1-.1.789 2.308 2.308 0 0 1-.374.789Z"
      />
      <path
        data-name="Path 161"
        d="M108.064 14.942a1.855 1.855 0 0 1-.371-.674 2.266 2.266 0 0 1-.1-.674 2.23 2.23 0 0 1 .1-.674.44.44 0 1 1 .745 0 2.233 2.233 0 0 1 .1.674 2.266 2.266 0 0 1-.1.674 1.854 1.854 0 0 1-.374.674Z"
      />
      <path
        data-name="Path 162"
        d="M107.117 14.942a1.855 1.855 0 0 1-.371-.674 2.264 2.264 0 0 1-.1-.674 2.238 2.238 0 0 1 .1-.674.44.44 0 1 1 .745 0 2.234 2.234 0 0 1 .1.674 2.269 2.269 0 0 1-.1.674 1.854 1.854 0 0 1-.374.674Z"
      />
      <path
        data-name="Path 163"
        d="M106.17 17.884a13.08 13.08 0 0 1-.371-2.145c-.069-.715-.1-1.43-.1-2.145s.032-1.43.1-2.145a12.891 12.891 0 0 1 .373-2.145 12.9 12.9 0 0 1 .372 2.145 22.978 22.978 0 0 1 0 4.29 13.083 13.083 0 0 1-.374 2.145Z"
      />
      <path
        data-name="Path 164"
        d="M105.223 23.319c-.2-1.621-.3-3.242-.371-4.862s-.1-3.241-.1-4.862.032-3.242.1-4.862.175-3.242.372-4.862c.2 1.621.3 3.241.373 4.862s.1 3.241.1 4.862-.033 3.241-.1 4.862-.178 3.242-.374 4.862Z"
      />
      <path
        data-name="Path 165"
        d="M104.275 24.489c-.2-1.816-.3-3.632-.371-5.447s-.1-3.632-.1-5.447.032-3.631.1-5.447.174-3.632.373-5.447c.2 1.816.3 3.631.372 5.447s.1 3.631.1 5.447-.033 3.632-.1 5.447-.176 3.631-.374 5.447Z"
      />
      <path
        data-name="Path 166"
        d="M103.328 26.634c-.2-2.173-.3-4.347-.368-6.52s-.1-4.347-.1-6.52.029-4.347.1-6.52.172-4.347.37-6.52c.2 2.173.3 4.346.37 6.52s.1 4.347.1 6.52-.03 4.346-.1 6.52-.176 4.347-.372 6.52Z"
      />
      <path
        data-name="Path 167"
        d="M102.381 23.958c-.2-1.727-.3-3.454-.371-5.182s-.1-3.454-.1-5.181.032-3.454.1-5.181.175-3.454.372-5.181c.2 1.727.3 3.454.372 5.181s.1 3.454.1 5.181-.033 3.454-.1 5.181-.177 3.454-.373 5.182Z"
      />
      <path
        data-name="Path 168"
        d="M101.434 15.513a3.006 3.006 0 0 1-.368-.959 4.27 4.27 0 0 1-.1-.959 4.2 4.2 0 0 1 .1-.959.551.551 0 1 1 .739 0 4.657 4.657 0 0 1 0 1.918 3 3 0 0 1-.361.959Z"
      />
      <path
        data-name="Path 169"
        d="M100.487 16.435a5.9 5.9 0 0 1-.368-1.42 9.276 9.276 0 0 1-.1-1.42 9.107 9.107 0 0 1 .1-1.42 5.821 5.821 0 0 1 .37-1.42 5.827 5.827 0 0 1 .37 1.42 9.13 9.13 0 0 1 .1 1.42 9.239 9.239 0 0 1-.1 1.42 5.893 5.893 0 0 1-.362 1.42Z"
      />
      <path
        data-name="Path 170"
        d="M99.54 14.786a1.536 1.536 0 0 1-.368-.6 1.7 1.7 0 0 1-.1-.6 1.676 1.676 0 0 1 .1-.6.413.413 0 1 1 .739 0 1.679 1.679 0 0 1 .1.6 1.7 1.7 0 0 1-.105.6 1.534 1.534 0 0 1-.361.6Z"
      />
      <path
        data-name="Path 171"
        d="M98.593 23.337c-.2-1.624-.3-3.248-.371-4.871s-.1-3.248-.1-4.871.032-3.248.1-4.871.175-3.248.373-4.871c.2 1.624.3 3.248.372 4.871s.1 3.248.1 4.871-.033 3.247-.1 4.871-.178 3.247-.374 4.871Z"
      />
      <path
        data-name="Path 172"
        d="M97.646 25.34c-.2-1.958-.3-3.915-.371-5.873s-.1-3.915-.1-5.873.032-3.915.1-5.873.174-3.915.372-5.873c.2 1.958.3 3.915.372 5.873s.1 3.915.1 5.873-.033 3.915-.1 5.873-.176 3.915-.373 5.873Z"
      />
      <path
        data-name="Path 173"
        d="M96.698 24.648c-.2-1.842-.3-3.685-.371-5.527s-.1-3.685-.1-5.527.032-3.684.1-5.527.174-3.685.373-5.527c.2 1.842.3 3.685.372 5.527s.1 3.685.1 5.527-.033 3.685-.1 5.527-.176 3.685-.374 5.527Z"
      />
      <path
        data-name="Path 174"
        d="M95.751 23.868c-.2-1.712-.3-3.425-.371-5.137s-.1-3.425-.1-5.137.032-3.425.1-5.137.175-3.425.372-5.137c.2 1.712.3 3.425.372 5.137s.1 3.425.1 5.137-.033 3.425-.1 5.137-.177 3.425-.373 5.137Z"
      />
      <path
        data-name="Path 175"
        d="M94.804 25.003c-.2-1.9-.3-3.8-.371-5.7s-.1-3.8-.1-5.7.032-3.8.1-5.7.174-3.8.372-5.7c.2 1.9.3 3.8.372 5.7s.1 3.8.1 5.7-.033 3.8-.1 5.7-.176 3.799-.373 5.7Z"
      />
      <path
        data-name="Path 176"
        d="M93.857 24.134c-.2-1.757-.3-3.513-.371-5.27s-.1-3.513-.1-5.27.032-3.513.1-5.27.175-3.514.372-5.27c.2 1.756.3 3.513.372 5.27s.1 3.513.1 5.27-.033 3.513-.1 5.27-.177 3.514-.373 5.27Z"
      />
      <path
        data-name="Path 177"
        d="M92.91 23.62c-.2-1.671-.3-3.342-.371-5.013s-.1-3.342-.1-5.013.032-3.342.1-5.013.175-3.342.372-5.013c.2 1.671.3 3.342.372 5.013s.1 3.342.1 5.013-.033 3.342-.1 5.013-.177 3.342-.373 5.013Z"
      />
      <path
        data-name="Path 178"
        d="M91.962 22.893c-.2-1.55-.3-3.1-.371-4.65s-.1-3.1-.1-4.649.032-3.1.1-4.65.175-3.1.373-4.65c.2 1.55.3 3.1.372 4.65s.1 3.1.1 4.65-.033 3.1-.1 4.649-.178 3.1-.374 4.65Z"
      />
      <path
        data-name="Path 179"
        d="M91.015 22.078c-.2-1.414-.3-2.828-.371-4.242s-.1-2.828-.1-4.242.032-2.828.1-4.242.175-2.828.372-4.242c.2 1.414.3 2.828.372 4.242s.1 2.828.1 4.242-.033 2.828-.1 4.242-.177 2.828-.373 4.242Z"
      />
      <path
        data-name="Path 180"
        d="M90.068 18.239a15.245 15.245 0 0 1-.371-2.322c-.07-.774-.1-1.548-.1-2.322s.032-1.548.1-2.322a15.038 15.038 0 0 1 .372-2.322 15.037 15.037 0 0 1 .372 2.322q.1 1.161.1 2.322t-.1 2.322a15.223 15.223 0 0 1-.373 2.322Z"
      />
      <path
        data-name="Path 181"
        d="M89.121 23.549c-.2-1.659-.3-3.318-.371-4.977s-.1-3.318-.1-4.977.031-3.319.1-4.978.175-3.318.372-4.977c.2 1.659.3 3.318.372 4.977s.1 3.318.1 4.978-.033 3.318-.1 4.977-.177 3.318-.373 4.977Z"
      />
      <path
        data-name="Path 182"
        d="M88.174 22.645c-.2-1.508-.3-3.017-.371-4.525s-.1-3.017-.1-4.525.032-3.017.1-4.526.175-3.017.372-4.525c.2 1.508.3 3.017.373 4.525s.1 3.017.1 4.526-.033 3.017-.1 4.525-.178 3.016-.374 4.525Z"
      />
      <path
        data-name="Path 183"
        d="M87.227 17.854a12.546 12.546 0 0 1-.368-2.129 20.681 20.681 0 0 1-.1-2.129 20.327 20.327 0 0 1 .1-2.129 12.388 12.388 0 0 1 .37-2.129 12.382 12.382 0 0 1 .37 2.129 21.739 21.739 0 0 1 0 4.259 12.527 12.527 0 0 1-.367 2.128Z"
      />
      <path
        data-name="Path 184"
        d="M86.28 23.412c-.2-1.636-.3-3.273-.368-4.909-.044-.818-.053-1.636-.079-2.454l-.026-2.454.025-2.454c.026-.818.035-1.636.079-2.454.069-1.636.172-3.273.37-4.909.2 1.636.3 3.273.37 4.909.044.818.052 1.636.079 2.454l.025 2.454-.026 2.454c-.026.818-.035 1.636-.079 2.454-.071 1.637-.174 3.269-.37 4.909Z"
      />
      <path
        data-name="Path 185"
        d="M85.333 25.901c-.2-2.051-.3-4.1-.368-6.153-.044-1.026-.053-2.051-.079-3.077l-.026-3.077.025-3.077c.026-1.026.035-2.051.079-3.077.069-2.051.172-4.1.37-6.153.2 2.051.3 4.1.37 6.153.044 1.025.052 2.051.079 3.077l.025 3.077-.026 3.077c-.026 1.026-.035 2.051-.079 3.077-.071 2.051-.174 4.102-.37 6.153Z"
      />
      <path
        data-name="Path 186"
        d="M84.385 24.582c-.2-1.831-.3-3.663-.368-5.494-.044-.916-.053-1.831-.079-2.747l-.026-2.747.025-2.747c.026-.916.035-1.831.079-2.747.069-1.831.172-3.662.37-5.494.2 1.831.3 3.663.37 5.494.044.916.052 1.831.079 2.747l.025 2.747-.026 2.747c-.026.916-.035 1.831-.079 2.747-.071 1.832-.174 3.663-.37 5.494Z"
      />
      <path
        data-name="Path 187"
        d="M83.438 18.572a16.949 16.949 0 0 1-.368-2.488c-.075-.829-.1-1.659-.1-2.488s.029-1.659.1-2.488a16.712 16.712 0 0 1 .37-2.488 16.7 16.7 0 0 1 .37 2.488c.075.829.1 1.659.1 2.488s-.03 1.659-.1 2.488a16.912 16.912 0 0 1-.372 2.488Z"
      />
      <path
        data-name="Path 188"
        d="M82.491 17.605a11.2 11.2 0 0 1-.368-2.005 18.364 18.364 0 0 1-.1-2.005 18.076 18.076 0 0 1 .1-2.005 11.048 11.048 0 0 1 .37-2 11.043 11.043 0 0 1 .37 2 19.287 19.287 0 0 1 0 4.011 11.173 11.173 0 0 1-.367 2Z"
      />
      <path
        data-name="Path 189"
        d="M81.544 26.244c-.2-2.108-.3-4.216-.368-6.325-.044-1.054-.053-2.108-.079-3.162l-.026-3.162.025-3.162c.026-1.054.035-2.108.079-3.162.069-2.108.172-4.217.37-6.325.2 2.108.3 4.216.37 6.325.044 1.054.052 2.108.079 3.162l.025 3.162-.026 3.162c-.026 1.054-.035 2.108-.079 3.162-.071 2.108-.174 4.216-.37 6.325Z"
      />
      <path
        data-name="Path 190"
        d="M80.597 27.2c-.2-2.268-.3-4.535-.368-6.8-.044-1.134-.053-2.268-.079-3.4l-.026-3.4.025-3.4c.026-1.134.035-2.268.079-3.4.069-2.268.172-4.535.37-6.8.2 2.268.3 4.535.37 6.8.044 1.134.052 2.268.079 3.4l.025 3.4-.026 3.4c-.026 1.134-.035 2.268-.079 3.4-.071 2.265-.174 4.532-.37 6.8Z"
      />
      <path
        data-name="Path 191"
        d="M79.65 26.63c-.2-2.173-.3-4.345-.368-6.518-.044-1.086-.053-2.173-.079-3.259l-.026-3.259.025-3.259c.026-1.086.035-2.173.079-3.259.069-2.173.172-4.345.37-6.518.2 2.173.3 4.345.37 6.518.044 1.086.052 2.173.079 3.259l.025 3.259-.026 3.259c-.026 1.086-.035 2.173-.079 3.259-.071 2.171-.174 4.346-.37 6.518Z"
      />
      <path
        data-name="Path 192"
        d="M78.702 17.236a9.327 9.327 0 0 1-.368-1.821 15.178 15.178 0 0 1-.1-1.821 14.912 14.912 0 0 1 .1-1.821 9.2 9.2 0 0 1 .37-1.821 9.207 9.207 0 0 1 .37 1.821 14.923 14.923 0 0 1 .1 1.821 15.156 15.156 0 0 1-.1 1.821 9.318 9.318 0 0 1-.367 1.821Z"
      />
      <path
        data-name="Path 193"
        d="M77.755 16.172a4.954 4.954 0 0 1-.368-1.288 7.644 7.644 0 0 1-.1-1.288 7.509 7.509 0 0 1 .1-1.288 4.894 4.894 0 0 1 .37-1.288 4.9 4.9 0 0 1 .37 1.288 7.524 7.524 0 0 1 .1 1.288 7.618 7.618 0 0 1-.1 1.288 4.947 4.947 0 0 1-.362 1.288Z"
      />
      <path
        data-name="Path 194"
        d="M76.808 15.355a2.624 2.624 0 0 1-.368-.88 3.607 3.607 0 0 1-.105-.88 3.546 3.546 0 0 1 .1-.88.518.518 0 1 1 .739 0 3.555 3.555 0 0 1 .1.88 3.6 3.6 0 0 1-.1.88 2.622 2.622 0 0 1-.361.88Z"
      />
      <path
        data-name="Path 195"
        d="M75.861 16.873a7.664 7.664 0 0 1-.368-1.639 12.3 12.3 0 0 1-.1-1.639 12.106 12.106 0 0 1 .1-1.639 7.559 7.559 0 0 1 .37-1.639 7.573 7.573 0 0 1 .37 1.639 12.116 12.116 0 0 1 .1 1.639 12.28 12.28 0 0 1-.1 1.639 7.666 7.666 0 0 1-.362 1.639Z"
      />
      <path
        data-name="Path 196"
        d="M74.914 26.212c-.2-2.1-.3-4.206-.371-6.309s-.1-4.206-.1-6.309.032-4.206.1-6.309.174-4.206.372-6.309c.2 2.1.3 4.206.372 6.309s.1 4.206.1 6.309-.033 4.206-.1 6.309-.176 4.206-.373 6.309Z"
      />
      <path
        data-name="Path 197"
        d="M73.966 25.092c-.2-1.916-.3-3.832-.371-5.749s-.1-3.833-.1-5.749.032-3.832.1-5.749.174-3.833.372-5.749c.2 1.916.3 3.833.372 5.749s.1 3.832.1 5.749-.033 3.833-.1 5.749-.176 3.833-.373 5.749Z"
      />
      <path
        data-name="Path 198"
        d="M73.019 25.386c-.2-1.965-.3-3.931-.371-5.9s-.1-3.93-.1-5.9.032-3.931.1-5.9.174-3.931.372-5.9c.2 1.965.3 3.931.372 5.9s.1 3.93.1 5.9-.033 3.93-.1 5.9-.176 3.935-.373 5.9Z"
      />
      <path
        data-name="Path 199"
        d="M72.072 24.632c-.2-1.84-.3-3.679-.371-5.519s-.1-3.679-.1-5.519.032-3.679.1-5.519.174-3.679.372-5.519c.2 1.84.3 3.679.372 5.519s.1 3.679.1 5.519-.033 3.679-.1 5.519-.175 3.679-.373 5.519Z"
      />
      <path
        data-name="Path 200"
        d="M71.125 25.386c-.2-1.965-.3-3.931-.371-5.9s-.1-3.93-.1-5.9.032-3.931.1-5.9.174-3.931.372-5.9c.2 1.965.3 3.931.372 5.9s.1 3.93.1 5.9-.033 3.93-.1 5.9-.176 3.935-.373 5.9Z"
      />
      <path
        data-name="Path 201"
        d="M70.178 22.545c-.2-1.492-.3-2.983-.371-4.475s-.1-2.983-.1-4.475.032-2.983.1-4.475.175-2.983.372-4.475c.2 1.492.3 2.983.372 4.475s.1 2.983.1 4.475-.033 2.983-.1 4.475-.177 2.983-.373 4.475Z"
      />
      <path
        data-name="Path 202"
        d="M69.231 18.669a18.124 18.124 0 0 1-.371-2.537c-.07-.846-.1-1.691-.1-2.537s.032-1.691.1-2.537a17.832 17.832 0 0 1 .372-2.537 17.826 17.826 0 0 1 .372 2.537q.1 1.269.1 2.537t-.1 2.537a18.126 18.126 0 0 1-.373 2.537Z"
      />
      <path
        data-name="Path 203"
        d="M68.284 22.24c-.2-1.441-.3-2.882-.371-4.323s-.1-2.882-.1-4.323.032-2.882.1-4.323.175-2.882.372-4.323c.2 1.441.3 2.882.372 4.323s.1 2.882.1 4.323-.033 2.882-.1 4.323-.177 2.882-.373 4.323Z"
      />
      <path
        data-name="Path 204"
        d="M67.336 18.35a15.943 15.943 0 0 1-.371-2.378c-.07-.793-.1-1.585-.1-2.378s.032-1.585.1-2.378a15.724 15.724 0 0 1 .372-2.378 15.727 15.727 0 0 1 .372 2.378q.1 1.189.1 2.378t-.1 2.378a15.943 15.943 0 0 1-.373 2.378Z"
      />
      <path
        data-name="Path 205"
        d="M66.389 18.35a15.942 15.942 0 0 1-.371-2.378c-.07-.793-.1-1.585-.1-2.378s.032-1.585.1-2.378a15.727 15.727 0 0 1 .372-2.378 15.722 15.722 0 0 1 .372 2.378q.1 1.189.1 2.378t-.1 2.378a15.951 15.951 0 0 1-.373 2.378Z"
      />
      <path
        data-name="Path 206"
        d="M65.442 18.948a20.1 20.1 0 0 1-.371-2.677c-.07-.892-.1-1.785-.1-2.677s.032-1.785.1-2.677a19.775 19.775 0 0 1 .372-2.677 19.771 19.771 0 0 1 .372 2.677q.1 1.338.1 2.677t-.1 2.677a20.1 20.1 0 0 1-.373 2.677Z"
      />
      <path
        data-name="Path 207"
        d="M64.495 18.182a14.9 14.9 0 0 1-.371-2.3c-.07-.765-.1-1.53-.1-2.3s.032-1.53.1-2.3a14.707 14.707 0 0 1 .372-2.3 14.7 14.7 0 0 1 .372 2.3q.1 1.148.1 2.3c0 .765-.033 1.53-.1 2.3a14.887 14.887 0 0 1-.373 2.3Z"
      />
      <path
        data-name="Path 208"
        d="M63.548 22.822c-.2-1.538-.3-3.076-.371-4.614s-.1-3.076-.1-4.614.032-3.076.1-4.614.175-3.076.372-4.614c.2 1.538.3 3.076.372 4.614s.1 3.076.1 4.614-.033 3.076-.1 4.614-.177 3.076-.373 4.614Z"
      />
      <path
        data-name="Path 209"
        d="M62.601 23.744c-.2-1.692-.3-3.383-.371-5.075s-.1-3.384-.1-5.075.032-3.383.1-5.075.175-3.383.372-5.075c.2 1.692.3 3.383.372 5.075s.1 3.383.1 5.075-.033 3.383-.1 5.075-.177 3.383-.373 5.075Z"
      />
      <path
        data-name="Path 210"
        d="M61.653 23.336c-.2-1.624-.3-3.248-.371-4.871s-.1-3.248-.1-4.871.032-3.248.1-4.871.175-3.248.372-4.871c.2 1.624.3 3.248.372 4.871s.1 3.248.1 4.871-.033 3.247-.1 4.871-.177 3.248-.373 4.871Z"
      />
      <path
        data-name="Path 211"
        d="M60.706 22.255c-.2-1.444-.3-2.887-.371-4.331s-.1-2.887-.1-4.331.032-2.887.1-4.331.175-2.887.373-4.331c.2 1.444.3 2.887.372 4.331s.1 2.887.1 4.331-.033 2.887-.1 4.331-.178 2.888-.374 4.331Z"
      />
      <path
        data-name="Path 212"
        d="M59.76 18.968a20.218 20.218 0 0 1-.371-2.686c-.069-.9-.1-1.791-.1-2.686s.032-1.791.1-2.686a19.9 19.9 0 0 1 .373-2.686 19.935 19.935 0 0 1 .372 2.686q.1 1.343.1 2.686c0 .9-.033 1.791-.1 2.686a20.232 20.232 0 0 1-.374 2.686Z"
      />
      <path
        data-name="Path 213"
        d="M58.812 18.292a15.549 15.549 0 0 1-.371-2.349c-.069-.783-.1-1.566-.1-2.349s.032-1.566.1-2.349a15.386 15.386 0 0 1 .372-2.349 15.37 15.37 0 0 1 .372 2.349q.1 1.175.1 2.349t-.1 2.349a15.523 15.523 0 0 1-.373 2.349Z"
      />
      <path
        data-name="Path 214"
        d="M57.865 18.968a20.244 20.244 0 0 1-.371-2.686c-.069-.9-.1-1.791-.1-2.686s.032-1.791.1-2.686a19.927 19.927 0 0 1 .372-2.686 19.912 19.912 0 0 1 .372 2.686q.1 1.343.1 2.686c0 .9-.033 1.791-.1 2.686a20.185 20.185 0 0 1-.373 2.686Z"
      />
      <path
        data-name="Path 215"
        d="M56.917 17.175a9.287 9.287 0 0 1-.371-1.79 15.635 15.635 0 0 1-.1-1.791 15.351 15.351 0 0 1 .1-1.791 9.189 9.189 0 0 1 .372-1.791 9.168 9.168 0 0 1 .372 1.791 15.277 15.277 0 0 1 .1 1.791 15.547 15.547 0 0 1-.1 1.791 9.27 9.27 0 0 1-.373 1.79Z"
      />
      <path
        data-name="Path 216"
        d="M55.97 15.722a3.665 3.665 0 0 1-.371-1.064 5.582 5.582 0 0 1-.1-1.064 5.461 5.461 0 0 1 .1-1.064 3.631 3.631 0 0 1 .372-1.064 3.623 3.623 0 0 1 .372 1.064 5.446 5.446 0 0 1 .1 1.064 5.543 5.543 0 0 1-.1 1.064 3.658 3.658 0 0 1-.373 1.064Z"
      />
      <path
        data-name="Path 217"
        d="M55.023 14.764a1.559 1.559 0 0 1-.371-.585 1.724 1.724 0 0 1-.1-.585 1.7 1.7 0 0 1 .1-.585.411.411 0 1 1 .745 0 1.7 1.7 0 0 1 .1.585 1.726 1.726 0 0 1-.1.585 1.555 1.555 0 0 1-.374.585Z"
      />
      <path
        data-name="Path 218"
        d="M54.076 14.837a1.675 1.675 0 0 1-.371-.622 1.933 1.933 0 0 1-.1-.622 1.909 1.909 0 0 1 .1-.622.422.422 0 1 1 .745 0 1.906 1.906 0 0 1 .1.622 1.934 1.934 0 0 1-.1.622 1.671 1.671 0 0 1-.374.622Z"
      />
      <path
        data-name="Path 219"
        d="M53.129 15.194a2.333 2.333 0 0 1-.371-.8 3.175 3.175 0 0 1-.1-.8 3.109 3.109 0 0 1 .1-.8 2.311 2.311 0 0 1 .372-.8 2.307 2.307 0 0 1 .372.8 3.1 3.1 0 0 1 .1.8 3.159 3.159 0 0 1-.1.8 2.328 2.328 0 0 1-.373.8Z"
      />
      <path
        data-name="Path 220"
        d="M52.182 15.194a2.332 2.332 0 0 1-.371-.8 3.173 3.173 0 0 1-.1-.8 3.107 3.107 0 0 1 .1-.8 2.31 2.31 0 0 1 .372-.8 2.307 2.307 0 0 1 .372.8 3.105 3.105 0 0 1 .1.8 3.157 3.157 0 0 1-.1.8 2.33 2.33 0 0 1-.373.8Z"
      />
      <path
        data-name="Path 221"
        d="M51.235 15.194a2.331 2.331 0 0 1-.371-.8 3.171 3.171 0 0 1-.1-.8 3.11 3.11 0 0 1 .1-.8 2.309 2.309 0 0 1 .372-.8 2.308 2.308 0 0 1 .372.8 3.107 3.107 0 0 1 .1.8 3.159 3.159 0 0 1-.1.8 2.329 2.329 0 0 1-.373.8Z"
      />
      <path
        data-name="Path 222"
        d="M50.287 15.722a3.666 3.666 0 0 1-.371-1.064 5.577 5.577 0 0 1-.1-1.064 5.465 5.465 0 0 1 .1-1.064 3.629 3.629 0 0 1 .372-1.064 3.623 3.623 0 0 1 .372 1.064 5.458 5.458 0 0 1 .1 1.064 5.55 5.55 0 0 1-.1 1.064 3.656 3.656 0 0 1-.373 1.064Z"
      />
      <path
        data-name="Path 223"
        d="M49.34 16.253a5.386 5.386 0 0 1-.371-1.33 8.654 8.654 0 0 1-.1-1.33 8.493 8.493 0 0 1 .1-1.33 5.333 5.333 0 0 1 .372-1.33 5.32 5.32 0 0 1 .372 1.33 8.466 8.466 0 0 1 .1 1.33 8.624 8.624 0 0 1-.1 1.33 5.373 5.373 0 0 1-.373 1.33Z"
      />
      <path
        data-name="Path 224"
        d="M48.393 16.253a5.384 5.384 0 0 1-.371-1.33 8.674 8.674 0 0 1-.1-1.33 8.489 8.489 0 0 1 .1-1.33 5.328 5.328 0 0 1 .372-1.33 5.322 5.322 0 0 1 .372 1.33 8.469 8.469 0 0 1 .1 1.33 8.613 8.613 0 0 1-.1 1.33 5.374 5.374 0 0 1-.373 1.33Z"
      />
      <path
        data-name="Path 225"
        d="M47.446 16.785a7.489 7.489 0 0 1-.371-1.6 12.427 12.427 0 0 1-.1-1.6 12.184 12.184 0 0 1 .1-1.6 7.414 7.414 0 0 1 .372-1.6 7.408 7.408 0 0 1 .372 1.6 12.169 12.169 0 0 1 .1 1.6 12.366 12.366 0 0 1-.1 1.6 7.478 7.478 0 0 1-.373 1.6Z"
      />
      <path
        data-name="Path 226"
        d="M46.499 18.434a16.548 16.548 0 0 1-.371-2.42c-.069-.807-.1-1.613-.1-2.42s.032-1.613.1-2.42a16.3 16.3 0 0 1 .372-2.42 16.26 16.26 0 0 1 .372 2.42q.1 1.21.1 2.42t-.1 2.42a16.491 16.491 0 0 1-.373 2.42Z"
      />
      <path
        data-name="Path 227"
        d="M45.552 26.368c-.2-2.129-.3-4.258-.371-6.387s-.1-4.258-.1-6.387.032-4.258.1-6.387.174-4.258.372-6.387c.2 2.129.3 4.258.372 6.387s.1 4.258.1 6.387-.033 4.258-.1 6.387-.175 4.259-.373 6.387Z"
      />
      <path
        data-name="Path 228"
        d="M44.604 25.818c-.2-2.038-.3-4.075-.371-6.112s-.1-4.075-.1-6.112.032-4.074.1-6.112.174-4.075.372-6.112c.2 2.038.3 4.075.372 6.112s.1 4.075.1 6.112-.033 4.075-.1 6.112-.175 4.075-.373 6.112Z"
      />
      <path
        data-name="Path 229"
        d="M43.657 15.212a2.309 2.309 0 0 1-.368-.809 3.059 3.059 0 0 1-.105-.809 3.007 3.007 0 0 1 .1-.809 2.287 2.287 0 0 1 .369-.809 2.284 2.284 0 0 1 .37.809 3.008 3.008 0 0 1 .1.809 3.056 3.056 0 0 1-.105.809 2.305 2.305 0 0 1-.361.809Z"
      />
      <path
        data-name="Path 230"
        d="M42.71 16.736a7.087 7.087 0 0 1-.368-1.571 11.278 11.278 0 0 1-.1-1.571 11.1 11.1 0 0 1 .1-1.571 7.01 7.01 0 0 1 .369-1.571 7 7 0 0 1 .37 1.571 11.111 11.111 0 0 1 .1 1.571 11.277 11.277 0 0 1-.1 1.571 7.068 7.068 0 0 1-.361 1.571Z"
      />
      <path
        data-name="Path 231"
        d="M41.763 24.05c-.2-1.743-.3-3.485-.368-5.228-.044-.871-.053-1.742-.079-2.614l-.026-2.614.025-2.614c.026-.871.035-1.743.079-2.614.069-1.743.172-3.485.369-5.228.2 1.743.3 3.485.37 5.228.044.871.052 1.743.079 2.614l.025 2.614-.026 2.614c-.026.871-.035 1.743-.079 2.614-.07 1.743-.173 3.486-.369 5.228Z"
      />
      <path
        data-name="Path 232"
        d="M40.816 23.164c-.2-1.6-.3-3.19-.368-4.785-.044-.8-.053-1.6-.079-2.392l-.026-2.392.025-2.392c.026-.8.035-1.6.079-2.392.069-1.6.172-3.19.369-4.785.2 1.6.3 3.19.37 4.785.044.8.052 1.6.079 2.392l.025 2.392-.026 2.392c-.026.8-.035 1.6-.079 2.392-.07 1.595-.173 3.19-.369 4.785Z"
      />
      <path
        data-name="Path 233"
        d="M39.869 23.739c-.2-1.691-.3-3.382-.371-5.073s-.1-3.382-.1-5.073.032-3.382.1-5.073.175-3.382.372-5.073c.2 1.691.3 3.382.372 5.073s.1 3.382.1 5.073-.033 3.382-.1 5.073-.177 3.382-.373 5.073Z"
      />
      <path
        data-name="Path 234"
        d="M38.921 25.604c-.2-2-.3-4-.371-6s-.1-4-.1-6 .032-4 .1-6 .174-4 .372-6c.2 2 .3 4 .372 6s.1 4 .1 6-.033 4-.1 6-.175 4-.373 6Z"
      />
      <path
        data-name="Path 235"
        d="M37.974 23.541c-.2-1.658-.3-3.315-.371-4.973s-.1-3.315-.1-4.973.032-3.315.1-4.973.175-3.315.372-4.973c.2 1.658.3 3.315.372 4.973s.1 3.315.1 4.973-.033 3.315-.1 4.973-.177 3.315-.373 4.973Z"
      />
      <path
        data-name="Path 236"
        d="M37.027 18.754a18.737 18.737 0 0 1-.371-2.58c-.069-.86-.1-1.72-.1-2.58s.032-1.72.1-2.58a18.443 18.443 0 0 1 .372-2.58 18.4 18.4 0 0 1 .372 2.58q.1 1.29.1 2.58t-.1 2.58a18.667 18.667 0 0 1-.373 2.58Z"
      />
      <path
        data-name="Path 237"
        d="M36.08 18.894a19.715 19.715 0 0 1-.371-2.65c-.069-.883-.1-1.767-.1-2.65s.032-1.767.1-2.65a19.4 19.4 0 0 1 .372-2.65 19.388 19.388 0 0 1 .372 2.65q.1 1.325.1 2.65t-.1 2.65a19.664 19.664 0 0 1-.373 2.65Z"
      />
      <path
        data-name="Path 238"
        d="M35.133 18.337a15.82 15.82 0 0 1-.371-2.371c-.069-.79-.1-1.581-.1-2.371s.032-1.581.1-2.371a15.671 15.671 0 0 1 .372-2.371 15.637 15.637 0 0 1 .372 2.371q.1 1.185.1 2.371t-.1 2.371a15.8 15.8 0 0 1-.373 2.371Z"
      />
      <path
        data-name="Path 239"
        d="M34.186 22.417c-.2-1.471-.3-2.941-.371-4.412s-.1-2.941-.1-4.412.032-2.941.1-4.412.175-2.941.372-4.412c.2 1.471.3 2.941.372 4.412s.1 2.941.1 4.412-.033 2.941-.1 4.412-.177 2.942-.373 4.412Z"
      />
      <path
        data-name="Path 240"
        d="M33.239 25.844c-.2-2.042-.3-4.083-.371-6.125s-.1-4.083-.1-6.125.032-4.083.1-6.124.174-4.083.372-6.125c.2 2.042.3 4.083.372 6.125s.1 4.083.1 6.124-.033 4.083-.1 6.125-.175 4.083-.373 6.125Z"
      />
      <path
        data-name="Path 241"
        d="M32.291 25.431c-.2-1.973-.3-3.946-.371-5.918s-.1-3.946-.1-5.918.032-3.946.1-5.918.174-3.945.372-5.918c.2 1.973.3 3.946.372 5.918s.1 3.945.1 5.918-.033 3.945-.1 5.918-.175 3.95-.373 5.918Z"
      />
      <path
        data-name="Path 242"
        d="M31.344 25.112c-.2-1.92-.3-3.839-.371-5.759s-.1-3.839-.1-5.759.032-3.839.1-5.759.174-3.839.372-5.759c.2 1.92.3 3.839.372 5.759s.1 3.839.1 5.759-.033 3.839-.1 5.759-.175 3.84-.373 5.759Z"
      />
      <path
        data-name="Path 243"
        d="M30.397 14.596a1.276 1.276 0 0 1-.368-.5 1.227 1.227 0 0 1-.1-.5 1.207 1.207 0 0 1 .1-.5.387.387 0 1 1 .739 0 1.207 1.207 0 0 1 .1.5 1.226 1.226 0 0 1-.1.5 1.275 1.275 0 0 1-.361.5Z"
      />
      <path
        data-name="Path 244"
        d="M29.45 25.47c-.2-1.979-.3-3.958-.371-5.938s-.1-3.959-.1-5.938.032-3.958.1-5.938.174-3.958.372-5.938c.2 1.979.3 3.958.372 5.938s.1 3.959.1 5.938-.033 3.959-.1 5.938-.175 3.959-.373 5.938Z"
      />
      <path
        data-name="Path 245"
        d="M28.503 18.528a16.644 16.644 0 0 1-.368-2.467c-.075-.822-.1-1.645-.1-2.467s.029-1.645.1-2.467a16.448 16.448 0 0 1 .369-2.467 16.42 16.42 0 0 1 .37 2.467c.075.822.1 1.645.1 2.467s-.03 1.645-.1 2.467a16.618 16.618 0 0 1-.361 2.467Z"
      />
      <path
        data-name="Path 246"
        d="M27.556 16.588a6.487 6.487 0 0 1-.368-1.5 10.249 10.249 0 0 1-.105-1.5 10.086 10.086 0 0 1 .1-1.5 6.415 6.415 0 0 1 .369-1.5 6.4 6.4 0 0 1 .37 1.5 10.086 10.086 0 0 1 .1 1.5 10.253 10.253 0 0 1-.1 1.5 6.475 6.475 0 0 1-.361 1.5Z"
      />
      <path
        data-name="Path 247"
        d="M26.608 15.149a2.178 2.178 0 0 1-.368-.777 2.826 2.826 0 0 1-.1-.777 2.782 2.782 0 0 1 .1-.777 2.156 2.156 0 0 1 .369-.777 2.153 2.153 0 0 1 .37.777 2.78 2.78 0 0 1 .1.777 2.826 2.826 0 0 1-.1.777 2.175 2.175 0 0 1-.361.777Z"
      />
      <path
        data-name="Path 248"
        d="M25.661 25.968c-.2-2.062-.3-4.124-.371-6.187s-.1-4.125-.1-6.187.032-4.125.1-6.187.174-4.124.372-6.187c.2 2.062.3 4.125.372 6.187s.1 4.125.1 6.187-.033 4.125-.1 6.187-.175 4.125-.373 6.187Z"
      />
      <path
        data-name="Path 249"
        d="M24.714 24.288c-.2-1.782-.3-3.565-.371-5.347s-.1-3.565-.1-5.346.032-3.565.1-5.347.174-3.565.372-5.347c.2 1.782.3 3.564.372 5.347s.1 3.565.1 5.347-.033 3.565-.1 5.346-.175 3.564-.373 5.347Z"
      />
      <path
        data-name="Path 250"
        d="M23.767 25.338c-.2-1.957-.3-3.915-.371-5.872s-.1-3.915-.1-5.872.032-3.915.1-5.872.174-3.915.372-5.872c.2 1.957.3 3.915.372 5.872s.1 3.915.1 5.872-.033 3.915-.1 5.872-.175 3.915-.373 5.872Z"
      />
      <path
        data-name="Path 251"
        d="M22.82 23.248c-.2-1.609-.3-3.218-.371-4.827s-.1-3.218-.1-4.827.032-3.218.1-4.827.175-3.218.372-4.827c.2 1.609.3 3.218.372 4.827s.1 3.218.1 4.827-.033 3.218-.1 4.827-.177 3.219-.373 4.827Z"
      />
      <path
        data-name="Path 252"
        d="M21.873 17.848a12.846 12.846 0 0 1-.371-2.126c-.069-.709-.1-1.418-.1-2.126s.032-1.418.1-2.126a12.711 12.711 0 0 1 .372-2.126 12.7 12.7 0 0 1 .372 2.126q.1 1.063.1 2.126t-.1 2.126a12.831 12.831 0 0 1-.373 2.126Z"
      />
      <path
        data-name="Path 253"
        d="M20.926 15.722a3.663 3.663 0 0 1-.371-1.064 5.573 5.573 0 0 1-.1-1.064 5.468 5.468 0 0 1 .1-1.064 3.629 3.629 0 0 1 .372-1.064 3.622 3.622 0 0 1 .372 1.064 5.448 5.448 0 0 1 .1 1.064 5.543 5.543 0 0 1-.1 1.064 3.658 3.658 0 0 1-.373 1.064Z"
      />
      <path
        data-name="Path 254"
        d="M19.978 16.785a7.49 7.49 0 0 1-.371-1.6 12.432 12.432 0 0 1-.1-1.6 12.191 12.191 0 0 1 .1-1.6 7.414 7.414 0 0 1 .372-1.6 7.4 7.4 0 0 1 .372 1.6 12.162 12.162 0 0 1 .1 1.6 12.363 12.363 0 0 1-.1 1.6 7.479 7.479 0 0 1-.373 1.6Z"
      />
      <path
        data-name="Path 255"
        d="M19.031 16.785a7.49 7.49 0 0 1-.371-1.6 12.427 12.427 0 0 1-.1-1.6 12.191 12.191 0 0 1 .1-1.6 7.416 7.416 0 0 1 .372-1.6 7.4 7.4 0 0 1 .372 1.6 12.159 12.159 0 0 1 .1 1.6 12.365 12.365 0 0 1-.1 1.6 7.479 7.479 0 0 1-.373 1.6Z"
      />
      <path
        data-name="Path 256"
        d="M18.084 23.248c-.2-1.609-.3-3.218-.371-4.827s-.1-3.218-.1-4.827.032-3.218.1-4.827.175-3.218.372-4.827c.2 1.609.3 3.218.372 4.827s.1 3.218.1 4.827-.033 3.218-.1 4.827-.177 3.219-.373 4.827Z"
      />
      <path
        data-name="Path 257"
        d="M17.137 24.329c-.2-1.789-.3-3.578-.371-5.368s-.1-3.578-.1-5.368.032-3.578.1-5.367.174-3.578.372-5.368c.2 1.789.3 3.578.372 5.368s.1 3.578.1 5.367-.033 3.578-.1 5.368-.175 3.579-.373 5.368Z"
      />
      <path
        data-name="Path 258"
        d="M16.19 22.839c-.2-1.54-.3-3.081-.371-4.622s-.1-3.081-.1-4.622.032-3.081.1-4.622.175-3.081.372-4.622c.2 1.541.3 3.081.372 4.622s.1 3.081.1 4.622-.033 3.081-.1 4.622-.177 3.081-.373 4.622Z"
      />
      <path
        data-name="Path 259"
        d="M15.243 26.094c-.2-2.083-.3-4.166-.371-6.249s-.1-4.166-.1-6.25.032-4.166.1-6.249.174-4.166.372-6.25c.2 2.083.3 4.166.372 6.25s.1 4.166.1 6.249-.033 4.166-.1 6.25-.175 4.166-.373 6.249Z"
      />
      <path
        data-name="Path 260"
        d="M14.295 24.507c-.2-1.819-.3-3.638-.371-5.456s-.1-3.637-.1-5.456.032-3.638.1-5.456.174-3.638.372-5.456c.2 1.819.3 3.637.372 5.456s.1 3.637.1 5.456-.033 3.638-.1 5.456-.175 3.637-.373 5.456Z"
      />
      <path
        data-name="Path 261"
        d="M13.348 23.248c-.2-1.609-.3-3.218-.371-4.827s-.1-3.218-.1-4.827.032-3.218.1-4.827.175-3.218.372-4.827c.2 1.609.3 3.218.372 4.827s.1 3.218.1 4.827-.033 3.218-.1 4.827-.177 3.219-.373 4.827Z"
      />
      <path
        data-name="Path 262"
        d="M12.401 21.884c-.2-1.382-.3-2.763-.371-4.144s-.1-2.763-.1-4.145.032-2.763.1-4.144.175-2.763.372-4.144c.2 1.381.3 2.763.372 4.144s.1 2.763.1 4.144-.033 2.763-.1 4.145-.177 2.762-.373 4.144Z"
      />
      <path
        data-name="Path 263"
        d="M11.454 22.839c-.2-1.54-.3-3.081-.371-4.622s-.1-3.081-.1-4.622.032-3.081.1-4.622.175-3.081.372-4.622c.2 1.541.3 3.081.372 4.622s.1 3.081.1 4.622-.033 3.081-.1 4.622-.177 3.081-.373 4.622Z"
      />
      <path
        data-name="Path 264"
        d="M10.507 18.657a18.047 18.047 0 0 1-.371-2.531c-.069-.844-.1-1.688-.1-2.531s.032-1.688.1-2.531a17.773 17.773 0 0 1 .372-2.531 17.75 17.75 0 0 1 .372 2.531q.1 1.266.1 2.531t-.1 2.531a17.983 17.983 0 0 1-.373 2.531Z"
      />
      <path
        data-name="Path 265"
        d="M9.56 17.756a12.328 12.328 0 0 1-.371-2.081c-.069-.693-.1-1.387-.1-2.081a20.683 20.683 0 0 1 .1-2.081 12.193 12.193 0 0 1 .372-2.081 12.173 12.173 0 0 1 .372 2.081 20.617 20.617 0 0 1 .1 2.081q0 1.041-.1 2.081a12.311 12.311 0 0 1-.373 2.081Z"
      />
      <path
        data-name="Path 266"
        d="M8.612 16.878a7.9 7.9 0 0 1-.371-1.642 13.16 13.16 0 0 1-.1-1.642 12.913 12.913 0 0 1 .1-1.642 7.819 7.819 0 0 1 .372-1.642 7.8 7.8 0 0 1 .372 1.642 12.872 12.872 0 0 1 .1 1.642 13.073 13.073 0 0 1-.1 1.642 7.885 7.885 0 0 1-.373 1.642Z"
      />
      <path
        data-name="Path 267"
        d="M7.665 15.722a3.663 3.663 0 0 1-.371-1.064 5.571 5.571 0 0 1-.1-1.064 5.466 5.466 0 0 1 .1-1.064 3.629 3.629 0 0 1 .372-1.064 3.624 3.624 0 0 1 .372 1.064 5.45 5.45 0 0 1 .1 1.064 5.543 5.543 0 0 1-.1 1.064 3.659 3.659 0 0 1-.373 1.064Z"
      />
      <path
        data-name="Path 268"
        d="M6.718 14.95a1.869 1.869 0 0 1-.371-.678 2.288 2.288 0 0 1-.1-.678 2.254 2.254 0 0 1 .1-.678 1.849 1.849 0 0 1 .372-.678 1.849 1.849 0 0 1 .372.678 2.254 2.254 0 0 1 .1.678 2.294 2.294 0 0 1-.1.678 1.864 1.864 0 0 1-.373.678Z"
      />
      <path
        data-name="Path 269"
        d="M5.771 14.845a1.685 1.685 0 0 1-.371-.625 1.956 1.956 0 0 1-.1-.625 1.926 1.926 0 0 1 .1-.625 1.669 1.669 0 0 1 .372-.625 1.669 1.669 0 0 1 .372.625 1.927 1.927 0 0 1 .1.625 1.961 1.961 0 0 1-.1.625 1.681 1.681 0 0 1-.373.625Z"
      />
      <path
        data-name="Path 270"
        d="M4.824 16.307a5.577 5.577 0 0 1-.371-1.356 9 9 0 0 1-.1-1.356 8.831 8.831 0 0 1 .1-1.356 5.522 5.522 0 0 1 .372-1.356 5.515 5.515 0 0 1 .372 1.356 8.809 8.809 0 0 1 .1 1.356 8.958 8.958 0 0 1-.1 1.356 5.57 5.57 0 0 1-.373 1.356Z"
      />
      <path
        data-name="Path 271"
        d="M3.877 14.897a1.775 1.775 0 0 1-.371-.651 2.119 2.119 0 0 1-.1-.652 2.088 2.088 0 0 1 .1-.651 1.757 1.757 0 0 1 .372-.652 1.757 1.757 0 0 1 .372.652 2.087 2.087 0 0 1 .1.651 2.124 2.124 0 0 1-.1.652 1.771 1.771 0 0 1-.373.651Z"
      />
      <path
        data-name="Path 272"
        d="M2.93 14.845a1.686 1.686 0 0 1-.371-.625 1.956 1.956 0 0 1-.1-.625 1.926 1.926 0 0 1 .1-.625 1.669 1.669 0 0 1 .372-.625 1.669 1.669 0 0 1 .372.625 1.927 1.927 0 0 1 .1.625 1.961 1.961 0 0 1-.1.625 1.681 1.681 0 0 1-.373.625Z"
      />
      <g data-name="Group 824">
        <path
          data-name="Path 151"
          d="M230.678 14.127H112.479a.535.535 0 0 1 0-1.064h118.2a.535.535 0 0 1 0 1.064Z"
        />
        <path
          data-name="Path 152"
          d="M228.588 15.722a3.663 3.663 0 0 1-.371-1.064 5.542 5.542 0 0 1-.1-1.064 5.465 5.465 0 0 1 .1-1.064.6.6 0 1 1 .745 0 5.47 5.47 0 0 1 .1 1.064 5.543 5.543 0 0 1-.1 1.064 3.664 3.664 0 0 1-.374 1.064Z"
        />
        <path
          data-name="Path 153"
          d="M227.641 17.175a9.3 9.3 0 0 1-.371-1.79 15.555 15.555 0 0 1-.1-1.791 15.335 15.335 0 0 1 .1-1.791 9.17 9.17 0 0 1 .372-1.791 9.17 9.17 0 0 1 .372 1.791 15.377 15.377 0 0 1 .1 1.791 15.608 15.608 0 0 1-.1 1.791 9.289 9.289 0 0 1-.373 1.79Z"
        />
        <path
          data-name="Path 154"
          d="M226.694 17.92a13.269 13.269 0 0 1-.371-2.163c-.07-.721-.1-1.442-.1-2.163s.032-1.442.1-2.163a13.1 13.1 0 0 1 .372-2.163 13.1 13.1 0 0 1 .372 2.163 23.364 23.364 0 0 1 0 4.326 13.278 13.278 0 0 1-.373 2.163Z"
        />
        <path
          data-name="Path 155"
          d="M225.747 18.788a18.963 18.963 0 0 1-.371-2.6c-.07-.866-.1-1.731-.1-2.6s.032-1.732.1-2.6a18.663 18.663 0 0 1 .373-2.6 18.662 18.662 0 0 1 .372 2.6q.1 1.3.1 2.6c0 .866-.033 1.731-.1 2.6a18.967 18.967 0 0 1-.374 2.6Z"
        />
        <path
          data-name="Path 156"
          d="M224.8 18.044a14.037 14.037 0 0 1-.371-2.225c-.07-.742-.1-1.483-.1-2.225s.032-1.483.1-2.225a13.833 13.833 0 0 1 .372-2.225 13.855 13.855 0 0 1 .372 2.225q.1 1.112.1 2.225t-.1 2.225a14.039 14.039 0 0 1-.373 2.225Z"
        />
        <path
          data-name="Path 157"
          d="M223.853 17.441a10.625 10.625 0 0 1-.371-1.923 17.91 17.91 0 0 1-.1-1.923 17.691 17.691 0 0 1 .1-1.923 10.5 10.5 0 0 1 .372-1.924 10.5 10.5 0 0 1 .372 1.924 17.706 17.706 0 0 1 .1 1.923 17.989 17.989 0 0 1-.1 1.923 10.627 10.627 0 0 1-.373 1.923Z"
        />
        <path
          data-name="Path 158"
          d="M222.906 16.785a7.5 7.5 0 0 1-.371-1.6 12.378 12.378 0 0 1-.1-1.6 12.184 12.184 0 0 1 .1-1.6 7.4 7.4 0 0 1 .372-1.6 7.4 7.4 0 0 1 .372 1.6 12.205 12.205 0 0 1 .1 1.6 12.409 12.409 0 0 1-.1 1.6 7.5 7.5 0 0 1-.373 1.6Z"
        />
        <path
          data-name="Path 159"
          d="M221.958 15.722a3.67 3.67 0 0 1-.371-1.064 5.554 5.554 0 0 1-.1-1.064 5.469 5.469 0 0 1 .1-1.064.6.6 0 1 1 .745 0 5.47 5.47 0 0 1 .1 1.064 5.538 5.538 0 0 1-.1 1.064 3.667 3.667 0 0 1-.374 1.064Z"
        />
        <path
          data-name="Path 160"
          d="M221.011 15.172a2.307 2.307 0 0 1-.371-.789 3.075 3.075 0 0 1-.1-.789 3.025 3.025 0 0 1 .1-.789.482.482 0 1 1 .745 0 3.03 3.03 0 0 1 .1.789 3.076 3.076 0 0 1-.1.789 2.308 2.308 0 0 1-.374.789Z"
        />
        <path
          data-name="Path 161"
          d="M220.064 14.942a1.855 1.855 0 0 1-.371-.674 2.266 2.266 0 0 1-.1-.674 2.23 2.23 0 0 1 .1-.674.44.44 0 1 1 .745 0 2.233 2.233 0 0 1 .1.674 2.266 2.266 0 0 1-.1.674 1.854 1.854 0 0 1-.374.674Z"
        />
        <path
          data-name="Path 162"
          d="M219.117 14.942a1.855 1.855 0 0 1-.371-.674 2.264 2.264 0 0 1-.1-.674 2.238 2.238 0 0 1 .1-.674.44.44 0 1 1 .745 0 2.234 2.234 0 0 1 .1.674 2.269 2.269 0 0 1-.1.674 1.854 1.854 0 0 1-.374.674Z"
        />
        <path
          data-name="Path 163"
          d="M218.17 17.884a13.08 13.08 0 0 1-.371-2.145c-.069-.715-.1-1.43-.1-2.145s.032-1.43.1-2.145a12.891 12.891 0 0 1 .373-2.145 12.9 12.9 0 0 1 .372 2.145 22.978 22.978 0 0 1 0 4.29 13.083 13.083 0 0 1-.374 2.145Z"
        />
        <path
          data-name="Path 164"
          d="M217.223 23.319c-.2-1.621-.3-3.242-.371-4.862s-.1-3.241-.1-4.862.032-3.242.1-4.862.175-3.242.372-4.862c.2 1.621.3 3.241.373 4.862s.1 3.241.1 4.862-.033 3.241-.1 4.862-.178 3.242-.374 4.862Z"
        />
        <path
          data-name="Path 165"
          d="M216.275 24.489c-.2-1.816-.3-3.632-.371-5.447s-.1-3.632-.1-5.447.032-3.631.1-5.447.174-3.632.373-5.447c.2 1.816.3 3.631.372 5.447s.1 3.631.1 5.447-.033 3.632-.1 5.447-.176 3.631-.374 5.447Z"
        />
        <path
          data-name="Path 166"
          d="M215.328 26.634c-.2-2.173-.3-4.347-.368-6.52s-.1-4.347-.1-6.52.029-4.347.1-6.52.172-4.347.37-6.52c.2 2.173.3 4.346.37 6.52s.1 4.347.1 6.52-.03 4.346-.1 6.52-.176 4.347-.372 6.52Z"
        />
        <path
          data-name="Path 167"
          d="M214.381 23.958c-.2-1.727-.3-3.454-.371-5.182s-.1-3.454-.1-5.181.032-3.454.1-5.181.175-3.454.372-5.181c.2 1.727.3 3.454.372 5.181s.1 3.454.1 5.181-.033 3.454-.1 5.181-.177 3.454-.373 5.182Z"
        />
        <path
          data-name="Path 168"
          d="M213.434 15.513a3.006 3.006 0 0 1-.368-.959 4.27 4.27 0 0 1-.1-.959 4.2 4.2 0 0 1 .1-.959.551.551 0 1 1 .739 0 4.657 4.657 0 0 1 0 1.918 3 3 0 0 1-.361.959Z"
        />
        <path
          data-name="Path 169"
          d="M212.487 16.435a5.9 5.9 0 0 1-.368-1.42 9.276 9.276 0 0 1-.1-1.42 9.107 9.107 0 0 1 .1-1.42 5.821 5.821 0 0 1 .37-1.42 5.827 5.827 0 0 1 .37 1.42 9.13 9.13 0 0 1 .1 1.42 9.239 9.239 0 0 1-.1 1.42 5.893 5.893 0 0 1-.362 1.42Z"
        />
        <path
          data-name="Path 170"
          d="M211.54 14.786a1.536 1.536 0 0 1-.368-.6 1.7 1.7 0 0 1-.1-.6 1.676 1.676 0 0 1 .1-.6.413.413 0 1 1 .739 0 1.679 1.679 0 0 1 .1.6 1.7 1.7 0 0 1-.105.6 1.534 1.534 0 0 1-.361.6Z"
        />
        <path
          data-name="Path 171"
          d="M210.593 23.337c-.2-1.624-.3-3.248-.371-4.871s-.1-3.248-.1-4.871.032-3.248.1-4.871.175-3.248.373-4.871c.2 1.624.3 3.248.372 4.871s.1 3.248.1 4.871-.033 3.247-.1 4.871-.178 3.247-.374 4.871Z"
        />
        <path
          data-name="Path 172"
          d="M209.646 25.34c-.2-1.958-.3-3.915-.371-5.873s-.1-3.915-.1-5.873.032-3.915.1-5.873.174-3.915.372-5.873c.2 1.958.3 3.915.372 5.873s.1 3.915.1 5.873-.033 3.915-.1 5.873-.176 3.915-.373 5.873Z"
        />
        <path
          data-name="Path 173"
          d="M208.698 24.648c-.2-1.842-.3-3.685-.371-5.527s-.1-3.685-.1-5.527.032-3.684.1-5.527.174-3.685.373-5.527c.2 1.842.3 3.685.372 5.527s.1 3.685.1 5.527-.033 3.685-.1 5.527-.176 3.685-.374 5.527Z"
        />
        <path
          data-name="Path 174"
          d="M207.751 23.868c-.2-1.712-.3-3.425-.371-5.137s-.1-3.425-.1-5.137.032-3.425.1-5.137.175-3.425.372-5.137c.2 1.712.3 3.425.372 5.137s.1 3.425.1 5.137-.033 3.425-.1 5.137-.177 3.425-.373 5.137Z"
        />
        <path
          data-name="Path 175"
          d="M206.804 25.003c-.2-1.9-.3-3.8-.371-5.7s-.1-3.8-.1-5.7.032-3.8.1-5.7.174-3.8.372-5.7c.2 1.9.3 3.8.372 5.7s.1 3.8.1 5.7-.033 3.8-.1 5.7-.176 3.799-.373 5.7Z"
        />
        <path
          data-name="Path 176"
          d="M205.857 24.134c-.2-1.757-.3-3.513-.371-5.27s-.1-3.513-.1-5.27.032-3.513.1-5.27.175-3.514.372-5.27c.2 1.756.3 3.513.372 5.27s.1 3.513.1 5.27-.033 3.513-.1 5.27-.177 3.514-.373 5.27Z"
        />
        <path
          data-name="Path 177"
          d="M204.91 23.62c-.2-1.671-.3-3.342-.371-5.013s-.1-3.342-.1-5.013.032-3.342.1-5.013.175-3.342.372-5.013c.2 1.671.3 3.342.372 5.013s.1 3.342.1 5.013-.033 3.342-.1 5.013-.177 3.342-.373 5.013Z"
        />
        <path
          data-name="Path 178"
          d="M203.962 22.893c-.2-1.55-.3-3.1-.371-4.65s-.1-3.1-.1-4.649.032-3.1.1-4.65.175-3.1.373-4.65c.2 1.55.3 3.1.372 4.65s.1 3.1.1 4.65-.033 3.1-.1 4.649-.178 3.1-.374 4.65Z"
        />
        <path
          data-name="Path 179"
          d="M203.015 22.078c-.2-1.414-.3-2.828-.371-4.242s-.1-2.828-.1-4.242.032-2.828.1-4.242.175-2.828.372-4.242c.2 1.414.3 2.828.372 4.242s.1 2.828.1 4.242-.033 2.828-.1 4.242-.177 2.828-.373 4.242Z"
        />
        <path
          data-name="Path 180"
          d="M202.068 18.239a15.245 15.245 0 0 1-.371-2.322c-.07-.774-.1-1.548-.1-2.322s.032-1.548.1-2.322a15.038 15.038 0 0 1 .372-2.322 15.037 15.037 0 0 1 .372 2.322q.1 1.161.1 2.322t-.1 2.322a15.223 15.223 0 0 1-.373 2.322Z"
        />
        <path
          data-name="Path 181"
          d="M201.121 23.549c-.2-1.659-.3-3.318-.371-4.977s-.1-3.318-.1-4.977.031-3.319.1-4.978.175-3.318.372-4.977c.2 1.659.3 3.318.372 4.977s.1 3.318.1 4.978-.033 3.318-.1 4.977-.177 3.318-.373 4.977Z"
        />
        <path
          data-name="Path 182"
          d="M200.174 22.645c-.2-1.508-.3-3.017-.371-4.525s-.1-3.017-.1-4.525.032-3.017.1-4.526.175-3.017.372-4.525c.2 1.508.3 3.017.373 4.525s.1 3.017.1 4.526-.033 3.017-.1 4.525-.178 3.016-.374 4.525Z"
        />
        <path
          data-name="Path 183"
          d="M199.227 17.854a12.546 12.546 0 0 1-.368-2.129 20.681 20.681 0 0 1-.1-2.129 20.327 20.327 0 0 1 .1-2.129 12.388 12.388 0 0 1 .37-2.129 12.382 12.382 0 0 1 .37 2.129 21.739 21.739 0 0 1 0 4.259 12.527 12.527 0 0 1-.367 2.128Z"
        />
        <path
          data-name="Path 184"
          d="M198.28 23.412c-.2-1.636-.3-3.273-.368-4.909-.044-.818-.053-1.636-.079-2.454l-.026-2.454.025-2.454c.026-.818.035-1.636.079-2.454.069-1.636.172-3.273.37-4.909.2 1.636.3 3.273.37 4.909.044.818.052 1.636.079 2.454l.025 2.454-.026 2.454c-.026.818-.035 1.636-.079 2.454-.071 1.637-.174 3.269-.37 4.909Z"
        />
        <path
          data-name="Path 185"
          d="M197.333 25.901c-.2-2.051-.3-4.1-.368-6.153-.044-1.026-.053-2.051-.079-3.077l-.026-3.077.025-3.077c.026-1.026.035-2.051.079-3.077.069-2.051.172-4.1.37-6.153.2 2.051.3 4.1.37 6.153.044 1.025.052 2.051.079 3.077l.025 3.077-.026 3.077c-.026 1.026-.035 2.051-.079 3.077-.071 2.051-.174 4.102-.37 6.153Z"
        />
        <path
          data-name="Path 186"
          d="M196.385 24.582c-.2-1.831-.3-3.663-.368-5.494-.044-.916-.053-1.831-.079-2.747l-.026-2.747.025-2.747c.026-.916.035-1.831.079-2.747.069-1.831.172-3.662.37-5.494.2 1.831.3 3.663.37 5.494.044.916.052 1.831.079 2.747l.025 2.747-.026 2.747c-.026.916-.035 1.831-.079 2.747-.071 1.832-.174 3.663-.37 5.494Z"
        />
        <path
          data-name="Path 187"
          d="M195.438 18.572a16.949 16.949 0 0 1-.368-2.488c-.075-.829-.1-1.659-.1-2.488s.029-1.659.1-2.488a16.712 16.712 0 0 1 .37-2.488 16.7 16.7 0 0 1 .37 2.488c.075.829.1 1.659.1 2.488s-.03 1.659-.1 2.488a16.912 16.912 0 0 1-.372 2.488Z"
        />
        <path
          data-name="Path 188"
          d="M194.491 17.605a11.2 11.2 0 0 1-.368-2.005 18.364 18.364 0 0 1-.1-2.005 18.076 18.076 0 0 1 .1-2.005 11.048 11.048 0 0 1 .37-2 11.043 11.043 0 0 1 .37 2 19.287 19.287 0 0 1 0 4.011 11.173 11.173 0 0 1-.367 2Z"
        />
        <path
          data-name="Path 189"
          d="M193.544 26.244c-.2-2.108-.3-4.216-.368-6.325-.044-1.054-.053-2.108-.079-3.162l-.026-3.162.025-3.162c.026-1.054.035-2.108.079-3.162.069-2.108.172-4.217.37-6.325.2 2.108.3 4.216.37 6.325.044 1.054.052 2.108.079 3.162l.025 3.162-.026 3.162c-.026 1.054-.035 2.108-.079 3.162-.071 2.108-.174 4.216-.37 6.325Z"
        />
        <path
          data-name="Path 190"
          d="M192.597 27.2c-.2-2.268-.3-4.535-.368-6.8-.044-1.134-.053-2.268-.079-3.4l-.026-3.4.025-3.4c.026-1.134.035-2.268.079-3.4.069-2.268.172-4.535.37-6.8.2 2.268.3 4.535.37 6.8.044 1.134.052 2.268.079 3.4l.025 3.4-.026 3.4c-.026 1.134-.035 2.268-.079 3.4-.071 2.265-.174 4.532-.37 6.8Z"
        />
        <path
          data-name="Path 191"
          d="M191.65 26.63c-.2-2.173-.3-4.345-.368-6.518-.044-1.086-.053-2.173-.079-3.259l-.026-3.259.025-3.259c.026-1.086.035-2.173.079-3.259.069-2.173.172-4.345.37-6.518.2 2.173.3 4.345.37 6.518.044 1.086.052 2.173.079 3.259l.025 3.259-.026 3.259c-.026 1.086-.035 2.173-.079 3.259-.071 2.171-.174 4.346-.37 6.518Z"
        />
        <path
          data-name="Path 192"
          d="M190.702 17.236a9.327 9.327 0 0 1-.368-1.821 15.178 15.178 0 0 1-.1-1.821 14.912 14.912 0 0 1 .1-1.821 9.2 9.2 0 0 1 .37-1.821 9.207 9.207 0 0 1 .37 1.821 14.923 14.923 0 0 1 .1 1.821 15.156 15.156 0 0 1-.1 1.821 9.318 9.318 0 0 1-.367 1.821Z"
        />
        <path
          data-name="Path 193"
          d="M189.755 16.172a4.954 4.954 0 0 1-.368-1.288 7.644 7.644 0 0 1-.1-1.288 7.509 7.509 0 0 1 .1-1.288 4.894 4.894 0 0 1 .37-1.288 4.9 4.9 0 0 1 .37 1.288 7.524 7.524 0 0 1 .1 1.288 7.618 7.618 0 0 1-.1 1.288 4.947 4.947 0 0 1-.362 1.288Z"
        />
        <path
          data-name="Path 194"
          d="M188.808 15.355a2.624 2.624 0 0 1-.368-.88 3.607 3.607 0 0 1-.105-.88 3.546 3.546 0 0 1 .1-.88.518.518 0 1 1 .739 0 3.555 3.555 0 0 1 .1.88 3.6 3.6 0 0 1-.1.88 2.622 2.622 0 0 1-.361.88Z"
        />
        <path
          data-name="Path 195"
          d="M187.861 16.873a7.664 7.664 0 0 1-.368-1.639 12.3 12.3 0 0 1-.1-1.639 12.106 12.106 0 0 1 .1-1.639 7.559 7.559 0 0 1 .37-1.639 7.573 7.573 0 0 1 .37 1.639 12.116 12.116 0 0 1 .1 1.639 12.28 12.28 0 0 1-.1 1.639 7.666 7.666 0 0 1-.362 1.639Z"
        />
        <path
          data-name="Path 196"
          d="M186.914 26.212c-.2-2.1-.3-4.206-.371-6.309s-.1-4.206-.1-6.309.032-4.206.1-6.309.174-4.206.372-6.309c.2 2.1.3 4.206.372 6.309s.1 4.206.1 6.309-.033 4.206-.1 6.309-.176 4.206-.373 6.309Z"
        />
        <path
          data-name="Path 197"
          d="M185.966 25.092c-.2-1.916-.3-3.832-.371-5.749s-.1-3.833-.1-5.749.032-3.832.1-5.749.174-3.833.372-5.749c.2 1.916.3 3.833.372 5.749s.1 3.832.1 5.749-.033 3.833-.1 5.749-.176 3.833-.373 5.749Z"
        />
        <path
          data-name="Path 198"
          d="M185.019 25.386c-.2-1.965-.3-3.931-.371-5.9s-.1-3.93-.1-5.9.032-3.931.1-5.9.174-3.931.372-5.9c.2 1.965.3 3.931.372 5.9s.1 3.93.1 5.9-.033 3.93-.1 5.9-.176 3.935-.373 5.9Z"
        />
        <path
          data-name="Path 199"
          d="M184.072 24.632c-.2-1.84-.3-3.679-.371-5.519s-.1-3.679-.1-5.519.032-3.679.1-5.519.174-3.679.372-5.519c.2 1.84.3 3.679.372 5.519s.1 3.679.1 5.519-.033 3.679-.1 5.519-.175 3.679-.373 5.519Z"
        />
        <path
          data-name="Path 200"
          d="M183.125 25.386c-.2-1.965-.3-3.931-.371-5.9s-.1-3.93-.1-5.9.032-3.931.1-5.9.174-3.931.372-5.9c.2 1.965.3 3.931.372 5.9s.1 3.93.1 5.9-.033 3.93-.1 5.9-.176 3.935-.373 5.9Z"
        />
        <path
          data-name="Path 201"
          d="M182.178 22.545c-.2-1.492-.3-2.983-.371-4.475s-.1-2.983-.1-4.475.032-2.983.1-4.475.175-2.983.372-4.475c.2 1.492.3 2.983.372 4.475s.1 2.983.1 4.475-.033 2.983-.1 4.475-.177 2.983-.373 4.475Z"
        />
        <path
          data-name="Path 202"
          d="M181.231 18.669a18.124 18.124 0 0 1-.371-2.537c-.07-.846-.1-1.691-.1-2.537s.032-1.691.1-2.537a17.832 17.832 0 0 1 .372-2.537 17.826 17.826 0 0 1 .372 2.537q.1 1.269.1 2.537t-.1 2.537a18.126 18.126 0 0 1-.373 2.537Z"
        />
        <path
          data-name="Path 203"
          d="M180.284 22.24c-.2-1.441-.3-2.882-.371-4.323s-.1-2.882-.1-4.323.032-2.882.1-4.323.175-2.882.372-4.323c.2 1.441.3 2.882.372 4.323s.1 2.882.1 4.323-.033 2.882-.1 4.323-.177 2.882-.373 4.323Z"
        />
        <path
          data-name="Path 204"
          d="M179.336 18.35a15.943 15.943 0 0 1-.371-2.378c-.07-.793-.1-1.585-.1-2.378s.032-1.585.1-2.378a15.724 15.724 0 0 1 .372-2.378 15.727 15.727 0 0 1 .372 2.378q.1 1.189.1 2.378t-.1 2.378a15.943 15.943 0 0 1-.373 2.378Z"
        />
        <path
          data-name="Path 205"
          d="M178.389 18.35a15.942 15.942 0 0 1-.371-2.378c-.07-.793-.1-1.585-.1-2.378s.032-1.585.1-2.378a15.727 15.727 0 0 1 .372-2.378 15.722 15.722 0 0 1 .372 2.378q.1 1.189.1 2.378t-.1 2.378a15.951 15.951 0 0 1-.373 2.378Z"
        />
        <path
          data-name="Path 206"
          d="M177.442 18.948a20.1 20.1 0 0 1-.371-2.677c-.07-.892-.1-1.785-.1-2.677s.032-1.785.1-2.677a19.775 19.775 0 0 1 .372-2.677 19.771 19.771 0 0 1 .372 2.677q.1 1.338.1 2.677t-.1 2.677a20.1 20.1 0 0 1-.373 2.677Z"
        />
        <path
          data-name="Path 207"
          d="M176.495 18.182a14.9 14.9 0 0 1-.371-2.3c-.07-.765-.1-1.53-.1-2.3s.032-1.53.1-2.3a14.707 14.707 0 0 1 .372-2.3 14.7 14.7 0 0 1 .372 2.3q.1 1.148.1 2.3c0 .765-.033 1.53-.1 2.3a14.887 14.887 0 0 1-.373 2.3Z"
        />
        <path
          data-name="Path 208"
          d="M175.548 22.822c-.2-1.538-.3-3.076-.371-4.614s-.1-3.076-.1-4.614.032-3.076.1-4.614.175-3.076.372-4.614c.2 1.538.3 3.076.372 4.614s.1 3.076.1 4.614-.033 3.076-.1 4.614-.177 3.076-.373 4.614Z"
        />
        <path
          data-name="Path 209"
          d="M174.601 23.744c-.2-1.692-.3-3.383-.371-5.075s-.1-3.384-.1-5.075.032-3.383.1-5.075.175-3.383.372-5.075c.2 1.692.3 3.383.372 5.075s.1 3.383.1 5.075-.033 3.383-.1 5.075-.177 3.383-.373 5.075Z"
        />
        <path
          data-name="Path 210"
          d="M173.653 23.336c-.2-1.624-.3-3.248-.371-4.871s-.1-3.248-.1-4.871.032-3.248.1-4.871.175-3.248.372-4.871c.2 1.624.3 3.248.372 4.871s.1 3.248.1 4.871-.033 3.247-.1 4.871-.177 3.248-.373 4.871Z"
        />
        <path
          data-name="Path 211"
          d="M172.706 22.255c-.2-1.444-.3-2.887-.371-4.331s-.1-2.887-.1-4.331.032-2.887.1-4.331.175-2.887.373-4.331c.2 1.444.3 2.887.372 4.331s.1 2.887.1 4.331-.033 2.887-.1 4.331-.178 2.888-.374 4.331Z"
        />
        <path
          data-name="Path 212"
          d="M171.76 18.968a20.218 20.218 0 0 1-.371-2.686c-.069-.9-.1-1.791-.1-2.686s.032-1.791.1-2.686a19.9 19.9 0 0 1 .373-2.686 19.935 19.935 0 0 1 .372 2.686q.1 1.343.1 2.686c0 .9-.033 1.791-.1 2.686a20.232 20.232 0 0 1-.374 2.686Z"
        />
        <path
          data-name="Path 213"
          d="M170.812 18.292a15.549 15.549 0 0 1-.371-2.349c-.069-.783-.1-1.566-.1-2.349s.032-1.566.1-2.349a15.386 15.386 0 0 1 .372-2.349 15.37 15.37 0 0 1 .372 2.349q.1 1.175.1 2.349t-.1 2.349a15.523 15.523 0 0 1-.373 2.349Z"
        />
        <path
          data-name="Path 214"
          d="M169.865 18.968a20.244 20.244 0 0 1-.371-2.686c-.069-.9-.1-1.791-.1-2.686s.032-1.791.1-2.686a19.927 19.927 0 0 1 .372-2.686 19.912 19.912 0 0 1 .372 2.686q.1 1.343.1 2.686c0 .9-.033 1.791-.1 2.686a20.185 20.185 0 0 1-.373 2.686Z"
        />
        <path
          data-name="Path 215"
          d="M168.917 17.175a9.287 9.287 0 0 1-.371-1.79 15.635 15.635 0 0 1-.1-1.791 15.351 15.351 0 0 1 .1-1.791 9.189 9.189 0 0 1 .372-1.791 9.168 9.168 0 0 1 .372 1.791 15.277 15.277 0 0 1 .1 1.791 15.547 15.547 0 0 1-.1 1.791 9.27 9.27 0 0 1-.373 1.79Z"
        />
        <path
          data-name="Path 216"
          d="M167.97 15.722a3.665 3.665 0 0 1-.371-1.064 5.582 5.582 0 0 1-.1-1.064 5.461 5.461 0 0 1 .1-1.064 3.631 3.631 0 0 1 .372-1.064 3.623 3.623 0 0 1 .372 1.064 5.446 5.446 0 0 1 .1 1.064 5.543 5.543 0 0 1-.1 1.064 3.658 3.658 0 0 1-.373 1.064Z"
        />
        <path
          data-name="Path 217"
          d="M167.023 14.764a1.559 1.559 0 0 1-.371-.585 1.724 1.724 0 0 1-.1-.585 1.7 1.7 0 0 1 .1-.585.411.411 0 1 1 .745 0 1.7 1.7 0 0 1 .1.585 1.726 1.726 0 0 1-.1.585 1.555 1.555 0 0 1-.374.585Z"
        />
        <path
          data-name="Path 218"
          d="M166.076 14.837a1.675 1.675 0 0 1-.371-.622 1.933 1.933 0 0 1-.1-.622 1.909 1.909 0 0 1 .1-.622.422.422 0 1 1 .745 0 1.906 1.906 0 0 1 .1.622 1.934 1.934 0 0 1-.1.622 1.671 1.671 0 0 1-.374.622Z"
        />
        <path
          data-name="Path 219"
          d="M165.129 15.194a2.333 2.333 0 0 1-.371-.8 3.175 3.175 0 0 1-.1-.8 3.109 3.109 0 0 1 .1-.8 2.311 2.311 0 0 1 .372-.8 2.307 2.307 0 0 1 .372.8 3.1 3.1 0 0 1 .1.8 3.159 3.159 0 0 1-.1.8 2.328 2.328 0 0 1-.373.8Z"
        />
        <path
          data-name="Path 220"
          d="M164.182 15.194a2.332 2.332 0 0 1-.371-.8 3.173 3.173 0 0 1-.1-.8 3.107 3.107 0 0 1 .1-.8 2.31 2.31 0 0 1 .372-.8 2.307 2.307 0 0 1 .372.8 3.105 3.105 0 0 1 .1.8 3.157 3.157 0 0 1-.1.8 2.33 2.33 0 0 1-.373.8Z"
        />
        <path
          data-name="Path 221"
          d="M163.235 15.194a2.331 2.331 0 0 1-.371-.8 3.171 3.171 0 0 1-.1-.8 3.11 3.11 0 0 1 .1-.8 2.309 2.309 0 0 1 .372-.8 2.308 2.308 0 0 1 .372.8 3.107 3.107 0 0 1 .1.8 3.159 3.159 0 0 1-.1.8 2.329 2.329 0 0 1-.373.8Z"
        />
        <path
          data-name="Path 222"
          d="M162.287 15.722a3.666 3.666 0 0 1-.371-1.064 5.577 5.577 0 0 1-.1-1.064 5.465 5.465 0 0 1 .1-1.064 3.629 3.629 0 0 1 .372-1.064 3.623 3.623 0 0 1 .372 1.064 5.458 5.458 0 0 1 .1 1.064 5.55 5.55 0 0 1-.1 1.064 3.656 3.656 0 0 1-.373 1.064Z"
        />
        <path
          data-name="Path 223"
          d="M161.34 16.253a5.386 5.386 0 0 1-.371-1.33 8.654 8.654 0 0 1-.1-1.33 8.493 8.493 0 0 1 .1-1.33 5.333 5.333 0 0 1 .372-1.33 5.32 5.32 0 0 1 .372 1.33 8.466 8.466 0 0 1 .1 1.33 8.624 8.624 0 0 1-.1 1.33 5.373 5.373 0 0 1-.373 1.33Z"
        />
        <path
          data-name="Path 224"
          d="M160.393 16.253a5.384 5.384 0 0 1-.371-1.33 8.674 8.674 0 0 1-.1-1.33 8.489 8.489 0 0 1 .1-1.33 5.328 5.328 0 0 1 .372-1.33 5.322 5.322 0 0 1 .372 1.33 8.469 8.469 0 0 1 .1 1.33 8.613 8.613 0 0 1-.1 1.33 5.374 5.374 0 0 1-.373 1.33Z"
        />
        <path
          data-name="Path 225"
          d="M159.446 16.785a7.489 7.489 0 0 1-.371-1.6 12.427 12.427 0 0 1-.1-1.6 12.184 12.184 0 0 1 .1-1.6 7.414 7.414 0 0 1 .372-1.6 7.408 7.408 0 0 1 .372 1.6 12.169 12.169 0 0 1 .1 1.6 12.366 12.366 0 0 1-.1 1.6 7.478 7.478 0 0 1-.373 1.6Z"
        />
        <path
          data-name="Path 226"
          d="M158.499 18.434a16.548 16.548 0 0 1-.371-2.42c-.069-.807-.1-1.613-.1-2.42s.032-1.613.1-2.42a16.3 16.3 0 0 1 .372-2.42 16.26 16.26 0 0 1 .372 2.42q.1 1.21.1 2.42t-.1 2.42a16.491 16.491 0 0 1-.373 2.42Z"
        />
        <path
          data-name="Path 227"
          d="M157.552 26.368c-.2-2.129-.3-4.258-.371-6.387s-.1-4.258-.1-6.387.032-4.258.1-6.387.174-4.258.372-6.387c.2 2.129.3 4.258.372 6.387s.1 4.258.1 6.387-.033 4.258-.1 6.387-.175 4.259-.373 6.387Z"
        />
        <path
          data-name="Path 228"
          d="M156.604 25.818c-.2-2.038-.3-4.075-.371-6.112s-.1-4.075-.1-6.112.032-4.074.1-6.112.174-4.075.372-6.112c.2 2.038.3 4.075.372 6.112s.1 4.075.1 6.112-.033 4.075-.1 6.112-.175 4.075-.373 6.112Z"
        />
        <path
          data-name="Path 229"
          d="M155.657 15.212a2.309 2.309 0 0 1-.368-.809 3.059 3.059 0 0 1-.105-.809 3.007 3.007 0 0 1 .1-.809 2.287 2.287 0 0 1 .369-.809 2.284 2.284 0 0 1 .37.809 3.008 3.008 0 0 1 .1.809 3.056 3.056 0 0 1-.105.809 2.305 2.305 0 0 1-.361.809Z"
        />
        <path
          data-name="Path 230"
          d="M154.71 16.736a7.087 7.087 0 0 1-.368-1.571 11.278 11.278 0 0 1-.1-1.571 11.1 11.1 0 0 1 .1-1.571 7.01 7.01 0 0 1 .369-1.571 7 7 0 0 1 .37 1.571 11.111 11.111 0 0 1 .1 1.571 11.277 11.277 0 0 1-.1 1.571 7.068 7.068 0 0 1-.361 1.571Z"
        />
        <path
          data-name="Path 231"
          d="M153.763 24.05c-.2-1.743-.3-3.485-.368-5.228-.044-.871-.053-1.742-.079-2.614l-.026-2.614.025-2.614c.026-.871.035-1.743.079-2.614.069-1.743.172-3.485.369-5.228.2 1.743.3 3.485.37 5.228.044.871.052 1.743.079 2.614l.025 2.614-.026 2.614c-.026.871-.035 1.743-.079 2.614-.07 1.743-.173 3.486-.369 5.228Z"
        />
        <path
          data-name="Path 232"
          d="M152.816 23.164c-.2-1.6-.3-3.19-.368-4.785-.044-.8-.053-1.6-.079-2.392l-.026-2.392.025-2.392c.026-.8.035-1.6.079-2.392.069-1.6.172-3.19.369-4.785.2 1.6.3 3.19.37 4.785.044.8.052 1.6.079 2.392l.025 2.392-.026 2.392c-.026.8-.035 1.6-.079 2.392-.07 1.595-.173 3.19-.369 4.785Z"
        />
        <path
          data-name="Path 233"
          d="M151.869 23.739c-.2-1.691-.3-3.382-.371-5.073s-.1-3.382-.1-5.073.032-3.382.1-5.073.175-3.382.372-5.073c.2 1.691.3 3.382.372 5.073s.1 3.382.1 5.073-.033 3.382-.1 5.073-.177 3.382-.373 5.073Z"
        />
        <path
          data-name="Path 234"
          d="M150.921 25.604c-.2-2-.3-4-.371-6s-.1-4-.1-6 .032-4 .1-6 .174-4 .372-6c.2 2 .3 4 .372 6s.1 4 .1 6-.033 4-.1 6-.175 4-.373 6Z"
        />
        <path
          data-name="Path 235"
          d="M149.974 23.541c-.2-1.658-.3-3.315-.371-4.973s-.1-3.315-.1-4.973.032-3.315.1-4.973.175-3.315.372-4.973c.2 1.658.3 3.315.372 4.973s.1 3.315.1 4.973-.033 3.315-.1 4.973-.177 3.315-.373 4.973Z"
        />
        <path
          data-name="Path 236"
          d="M149.027 18.754a18.737 18.737 0 0 1-.371-2.58c-.069-.86-.1-1.72-.1-2.58s.032-1.72.1-2.58a18.443 18.443 0 0 1 .372-2.58 18.4 18.4 0 0 1 .372 2.58q.1 1.29.1 2.58t-.1 2.58a18.667 18.667 0 0 1-.373 2.58Z"
        />
        <path
          data-name="Path 237"
          d="M148.08 18.894a19.715 19.715 0 0 1-.371-2.65c-.069-.883-.1-1.767-.1-2.65s.032-1.767.1-2.65a19.4 19.4 0 0 1 .372-2.65 19.388 19.388 0 0 1 .372 2.65q.1 1.325.1 2.65t-.1 2.65a19.664 19.664 0 0 1-.373 2.65Z"
        />
        <path
          data-name="Path 238"
          d="M147.133 18.337a15.82 15.82 0 0 1-.371-2.371c-.069-.79-.1-1.581-.1-2.371s.032-1.581.1-2.371a15.671 15.671 0 0 1 .372-2.371 15.637 15.637 0 0 1 .372 2.371q.1 1.185.1 2.371t-.1 2.371a15.8 15.8 0 0 1-.373 2.371Z"
        />
        <path
          data-name="Path 239"
          d="M146.186 22.417c-.2-1.471-.3-2.941-.371-4.412s-.1-2.941-.1-4.412.032-2.941.1-4.412.175-2.941.372-4.412c.2 1.471.3 2.941.372 4.412s.1 2.941.1 4.412-.033 2.941-.1 4.412-.177 2.942-.373 4.412Z"
        />
        <path
          data-name="Path 240"
          d="M145.239 25.844c-.2-2.042-.3-4.083-.371-6.125s-.1-4.083-.1-6.125.032-4.083.1-6.124.174-4.083.372-6.125c.2 2.042.3 4.083.372 6.125s.1 4.083.1 6.124-.033 4.083-.1 6.125-.175 4.083-.373 6.125Z"
        />
        <path
          data-name="Path 241"
          d="M144.291 25.431c-.2-1.973-.3-3.946-.371-5.918s-.1-3.946-.1-5.918.032-3.946.1-5.918.174-3.945.372-5.918c.2 1.973.3 3.946.372 5.918s.1 3.945.1 5.918-.033 3.945-.1 5.918-.175 3.95-.373 5.918Z"
        />
        <path
          data-name="Path 242"
          d="M143.344 25.112c-.2-1.92-.3-3.839-.371-5.759s-.1-3.839-.1-5.759.032-3.839.1-5.759.174-3.839.372-5.759c.2 1.92.3 3.839.372 5.759s.1 3.839.1 5.759-.033 3.839-.1 5.759-.175 3.84-.373 5.759Z"
        />
        <path
          data-name="Path 243"
          d="M142.397 14.596a1.276 1.276 0 0 1-.368-.5 1.227 1.227 0 0 1-.1-.5 1.207 1.207 0 0 1 .1-.5.387.387 0 1 1 .739 0 1.207 1.207 0 0 1 .1.5 1.226 1.226 0 0 1-.1.5 1.275 1.275 0 0 1-.361.5Z"
        />
        <path
          data-name="Path 244"
          d="M141.45 25.47c-.2-1.979-.3-3.958-.371-5.938s-.1-3.959-.1-5.938.032-3.958.1-5.938.174-3.958.372-5.938c.2 1.979.3 3.958.372 5.938s.1 3.959.1 5.938-.033 3.959-.1 5.938-.175 3.959-.373 5.938Z"
        />
        <path
          data-name="Path 245"
          d="M140.503 18.528a16.644 16.644 0 0 1-.368-2.467c-.075-.822-.1-1.645-.1-2.467s.029-1.645.1-2.467a16.448 16.448 0 0 1 .369-2.467 16.42 16.42 0 0 1 .37 2.467c.075.822.1 1.645.1 2.467s-.03 1.645-.1 2.467a16.618 16.618 0 0 1-.361 2.467Z"
        />
        <path
          data-name="Path 246"
          d="M139.556 16.588a6.487 6.487 0 0 1-.368-1.5 10.249 10.249 0 0 1-.105-1.5 10.086 10.086 0 0 1 .1-1.5 6.415 6.415 0 0 1 .369-1.5 6.4 6.4 0 0 1 .37 1.5 10.086 10.086 0 0 1 .1 1.5 10.253 10.253 0 0 1-.1 1.5 6.475 6.475 0 0 1-.361 1.5Z"
        />
        <path
          data-name="Path 247"
          d="M138.608 15.149a2.178 2.178 0 0 1-.368-.777 2.826 2.826 0 0 1-.1-.777 2.782 2.782 0 0 1 .1-.777 2.156 2.156 0 0 1 .369-.777 2.153 2.153 0 0 1 .37.777 2.78 2.78 0 0 1 .1.777 2.826 2.826 0 0 1-.1.777 2.175 2.175 0 0 1-.361.777Z"
        />
        <path
          data-name="Path 248"
          d="M137.661 25.968c-.2-2.062-.3-4.124-.371-6.187s-.1-4.125-.1-6.187.032-4.125.1-6.187.174-4.124.372-6.187c.2 2.062.3 4.125.372 6.187s.1 4.125.1 6.187-.033 4.125-.1 6.187-.175 4.125-.373 6.187Z"
        />
        <path
          data-name="Path 249"
          d="M136.714 24.288c-.2-1.782-.3-3.565-.371-5.347s-.1-3.565-.1-5.346.032-3.565.1-5.347.174-3.565.372-5.347c.2 1.782.3 3.564.372 5.347s.1 3.565.1 5.347-.033 3.565-.1 5.346-.175 3.564-.373 5.347Z"
        />
        <path
          data-name="Path 250"
          d="M135.767 25.338c-.2-1.957-.3-3.915-.371-5.872s-.1-3.915-.1-5.872.032-3.915.1-5.872.174-3.915.372-5.872c.2 1.957.3 3.915.372 5.872s.1 3.915.1 5.872-.033 3.915-.1 5.872-.175 3.915-.373 5.872Z"
        />
        <path
          data-name="Path 251"
          d="M134.82 23.248c-.2-1.609-.3-3.218-.371-4.827s-.1-3.218-.1-4.827.032-3.218.1-4.827.175-3.218.372-4.827c.2 1.609.3 3.218.372 4.827s.1 3.218.1 4.827-.033 3.218-.1 4.827-.177 3.219-.373 4.827Z"
        />
        <path
          data-name="Path 252"
          d="M133.873 17.848a12.846 12.846 0 0 1-.371-2.126c-.069-.709-.1-1.418-.1-2.126s.032-1.418.1-2.126a12.711 12.711 0 0 1 .372-2.126 12.7 12.7 0 0 1 .372 2.126q.1 1.063.1 2.126t-.1 2.126a12.831 12.831 0 0 1-.373 2.126Z"
        />
        <path
          data-name="Path 253"
          d="M132.926 15.722a3.663 3.663 0 0 1-.371-1.064 5.573 5.573 0 0 1-.1-1.064 5.468 5.468 0 0 1 .1-1.064 3.629 3.629 0 0 1 .372-1.064 3.622 3.622 0 0 1 .372 1.064 5.448 5.448 0 0 1 .1 1.064 5.543 5.543 0 0 1-.1 1.064 3.658 3.658 0 0 1-.373 1.064Z"
        />
        <path
          data-name="Path 254"
          d="M131.978 16.785a7.49 7.49 0 0 1-.371-1.6 12.432 12.432 0 0 1-.1-1.6 12.191 12.191 0 0 1 .1-1.6 7.414 7.414 0 0 1 .372-1.6 7.4 7.4 0 0 1 .372 1.6 12.162 12.162 0 0 1 .1 1.6 12.363 12.363 0 0 1-.1 1.6 7.479 7.479 0 0 1-.373 1.6Z"
        />
        <path
          data-name="Path 255"
          d="M131.031 16.785a7.49 7.49 0 0 1-.371-1.6 12.427 12.427 0 0 1-.1-1.6 12.191 12.191 0 0 1 .1-1.6 7.416 7.416 0 0 1 .372-1.6 7.4 7.4 0 0 1 .372 1.6 12.159 12.159 0 0 1 .1 1.6 12.365 12.365 0 0 1-.1 1.6 7.479 7.479 0 0 1-.373 1.6Z"
        />
        <path
          data-name="Path 256"
          d="M130.084 23.248c-.2-1.609-.3-3.218-.371-4.827s-.1-3.218-.1-4.827.032-3.218.1-4.827.175-3.218.372-4.827c.2 1.609.3 3.218.372 4.827s.1 3.218.1 4.827-.033 3.218-.1 4.827-.177 3.219-.373 4.827Z"
        />
        <path
          data-name="Path 257"
          d="M129.137 24.329c-.2-1.789-.3-3.578-.371-5.368s-.1-3.578-.1-5.368.032-3.578.1-5.367.174-3.578.372-5.368c.2 1.789.3 3.578.372 5.368s.1 3.578.1 5.367-.033 3.578-.1 5.368-.175 3.579-.373 5.368Z"
        />
        <path
          data-name="Path 258"
          d="M128.19 22.839c-.2-1.54-.3-3.081-.371-4.622s-.1-3.081-.1-4.622.032-3.081.1-4.622.175-3.081.372-4.622c.2 1.541.3 3.081.372 4.622s.1 3.081.1 4.622-.033 3.081-.1 4.622-.177 3.081-.373 4.622Z"
        />
        <path
          data-name="Path 259"
          d="M127.243 26.094c-.2-2.083-.3-4.166-.371-6.249s-.1-4.166-.1-6.25.032-4.166.1-6.249.174-4.166.372-6.25c.2 2.083.3 4.166.372 6.25s.1 4.166.1 6.249-.033 4.166-.1 6.25-.175 4.166-.373 6.249Z"
        />
        <path
          data-name="Path 260"
          d="M126.295 24.507c-.2-1.819-.3-3.638-.371-5.456s-.1-3.637-.1-5.456.032-3.638.1-5.456.174-3.638.372-5.456c.2 1.819.3 3.637.372 5.456s.1 3.637.1 5.456-.033 3.638-.1 5.456-.175 3.637-.373 5.456Z"
        />
        <path
          data-name="Path 261"
          d="M125.348 23.248c-.2-1.609-.3-3.218-.371-4.827s-.1-3.218-.1-4.827.032-3.218.1-4.827.175-3.218.372-4.827c.2 1.609.3 3.218.372 4.827s.1 3.218.1 4.827-.033 3.218-.1 4.827-.177 3.219-.373 4.827Z"
        />
        <path
          data-name="Path 262"
          d="M124.401 21.884c-.2-1.382-.3-2.763-.371-4.144s-.1-2.763-.1-4.145.032-2.763.1-4.144.175-2.763.372-4.144c.2 1.381.3 2.763.372 4.144s.1 2.763.1 4.144-.033 2.763-.1 4.145-.177 2.762-.373 4.144Z"
        />
        <path
          data-name="Path 263"
          d="M123.454 22.839c-.2-1.54-.3-3.081-.371-4.622s-.1-3.081-.1-4.622.032-3.081.1-4.622.175-3.081.372-4.622c.2 1.541.3 3.081.372 4.622s.1 3.081.1 4.622-.033 3.081-.1 4.622-.177 3.081-.373 4.622Z"
        />
        <path
          data-name="Path 264"
          d="M122.507 18.657a18.047 18.047 0 0 1-.371-2.531c-.069-.844-.1-1.688-.1-2.531s.032-1.688.1-2.531a17.773 17.773 0 0 1 .372-2.531 17.75 17.75 0 0 1 .372 2.531q.1 1.266.1 2.531t-.1 2.531a17.983 17.983 0 0 1-.373 2.531Z"
        />
        <path
          data-name="Path 265"
          d="M121.56 17.756a12.328 12.328 0 0 1-.371-2.081c-.069-.693-.1-1.387-.1-2.081a20.683 20.683 0 0 1 .1-2.081 12.193 12.193 0 0 1 .372-2.081 12.173 12.173 0 0 1 .372 2.081 20.617 20.617 0 0 1 .1 2.081q0 1.041-.1 2.081a12.311 12.311 0 0 1-.373 2.081Z"
        />
        <path
          data-name="Path 266"
          d="M120.612 16.878a7.9 7.9 0 0 1-.371-1.642 13.16 13.16 0 0 1-.1-1.642 12.913 12.913 0 0 1 .1-1.642 7.819 7.819 0 0 1 .372-1.642 7.8 7.8 0 0 1 .372 1.642 12.872 12.872 0 0 1 .1 1.642 13.073 13.073 0 0 1-.1 1.642 7.885 7.885 0 0 1-.373 1.642Z"
        />
        <path
          data-name="Path 267"
          d="M119.665 15.722a3.663 3.663 0 0 1-.371-1.064 5.571 5.571 0 0 1-.1-1.064 5.466 5.466 0 0 1 .1-1.064 3.629 3.629 0 0 1 .372-1.064 3.624 3.624 0 0 1 .372 1.064 5.45 5.45 0 0 1 .1 1.064 5.543 5.543 0 0 1-.1 1.064 3.659 3.659 0 0 1-.373 1.064Z"
        />
        <path
          data-name="Path 268"
          d="M118.718 14.95a1.869 1.869 0 0 1-.371-.678 2.288 2.288 0 0 1-.1-.678 2.254 2.254 0 0 1 .1-.678 1.849 1.849 0 0 1 .372-.678 1.849 1.849 0 0 1 .372.678 2.254 2.254 0 0 1 .1.678 2.294 2.294 0 0 1-.1.678 1.864 1.864 0 0 1-.373.678Z"
        />
        <path
          data-name="Path 269"
          d="M117.771 14.845a1.685 1.685 0 0 1-.371-.625 1.956 1.956 0 0 1-.1-.625 1.926 1.926 0 0 1 .1-.625 1.669 1.669 0 0 1 .372-.625 1.669 1.669 0 0 1 .372.625 1.927 1.927 0 0 1 .1.625 1.961 1.961 0 0 1-.1.625 1.681 1.681 0 0 1-.373.625Z"
        />
        <path
          data-name="Path 270"
          d="M116.824 16.307a5.577 5.577 0 0 1-.371-1.356 9 9 0 0 1-.1-1.356 8.831 8.831 0 0 1 .1-1.356 5.522 5.522 0 0 1 .372-1.356 5.515 5.515 0 0 1 .372 1.356 8.809 8.809 0 0 1 .1 1.356 8.958 8.958 0 0 1-.1 1.356 5.57 5.57 0 0 1-.373 1.356Z"
        />
        <path
          data-name="Path 271"
          d="M115.877 14.897a1.775 1.775 0 0 1-.371-.651 2.119 2.119 0 0 1-.1-.652 2.088 2.088 0 0 1 .1-.651 1.757 1.757 0 0 1 .372-.652 1.757 1.757 0 0 1 .372.652 2.087 2.087 0 0 1 .1.651 2.124 2.124 0 0 1-.1.652 1.771 1.771 0 0 1-.373.651Z"
        />
        <path
          data-name="Path 272"
          d="M114.93 14.845a1.686 1.686 0 0 1-.371-.625 1.956 1.956 0 0 1-.1-.625 1.926 1.926 0 0 1 .1-.625 1.669 1.669 0 0 1 .372-.625 1.669 1.669 0 0 1 .372.625 1.927 1.927 0 0 1 .1.625 1.961 1.961 0 0 1-.1.625 1.681 1.681 0 0 1-.373.625Z"
        />
      </g>
    </g>
  </svg>
);

export default SoundWaveIcon;
